import { e as Y, o as ee, f as Pe, $ as O, a as C, h as ue, k as _e, u as I, s as T, l as we, m as ae, n as xe, q as re, r as qe, F as Se, _ as Ne, i as De, c as Ve, b as Ce, d as Ee } from "./_plugin-vue_export-helper-xSr69O-G.js";
import { defineComponent as w, createElementBlock as d, openBlock as c, createElementVNode as r, Fragment as g, renderList as V, normalizeClass as $, toDisplayString as m, createVNode as h, createCommentVNode as y, unref as i, createBlock as N, onMounted as Me, useTemplateRef as pe, ref as D, createTextVNode as X, nextTick as Ue, computed as z, inject as me, withModifiers as U, watch as Ae, resolveComponent as Te, isRef as ie, withCtx as A, useModel as ke, mergeModels as Re, withAsyncContext as Ze, Suspense as Le, createStaticVNode as Be } from "vue";
import { f as H, g as L, u as Oe, _ as Ie, a as Fe, h as ve, j as Je, t as oe, k as Ke, l as Qe, m as He, n as We, o as Ye, p as se, q as Ge, r as Xe } from "./EPrescriptionInputOptions.vue_vue_type_script_setup_true_lang-DD9MLj1T.js";
import { c as eo, s as ce, m as ye, a as he, b as oo, d as to, u as be, f as no, l as ao } from "./index-DVT7wwhS.js";
import { a as ro } from "./addDays-Dik7NbVo.js";
function fe(o) {
  return eo(o, Date.now());
}
function ze(o, e) {
  const t = ce(o), n = ce(e);
  return +t == +n;
}
function io(o) {
  return ze(o, fe(o));
}
function so(o) {
  return ze(o, ro(fe(o), 1));
}
function co(o, e) {
  const n = po(o);
  let a;
  if (n.date) {
    const _ = mo(n.date, 2);
    a = ko(_.restDateString, _.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const l = a.getTime();
  let s = 0, u;
  if (n.time && (s = vo(n.time), isNaN(s)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (u = yo(n.timezone), isNaN(u))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const _ = new Date(l + s), p = /* @__PURE__ */ new Date(0);
    return p.setFullYear(
      _.getUTCFullYear(),
      _.getUTCMonth(),
      _.getUTCDate()
    ), p.setHours(
      _.getUTCHours(),
      _.getUTCMinutes(),
      _.getUTCSeconds(),
      _.getUTCMilliseconds()
    ), p;
  }
  return new Date(l + s + u);
}
const K = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, lo = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, uo = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, _o = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function po(o) {
  const e = {}, t = o.split(K.dateTimeDelimiter);
  let n;
  if (t.length > 2)
    return e;
  if (/:/.test(t[0]) ? n = t[0] : (e.date = t[0], n = t[1], K.timeZoneDelimiter.test(e.date) && (e.date = o.split(K.timeZoneDelimiter)[0], n = o.substr(
    e.date.length,
    o.length
  ))), n) {
    const a = K.timezone.exec(n);
    a ? (e.time = n.replace(a[1], ""), e.timezone = a[1]) : e.time = n;
  }
  return e;
}
function mo(o, e) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), n = o.match(t);
  if (!n) return { year: NaN, restDateString: "" };
  const a = n[1] ? parseInt(n[1]) : null, l = n[2] ? parseInt(n[2]) : null;
  return {
    year: l === null ? a : l * 100,
    restDateString: o.slice((n[1] || n[2]).length)
  };
}
function ko(o, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const t = o.match(lo);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const n = !!t[4], a = B(t[1]), l = B(t[2]) - 1, s = B(t[3]), u = B(t[4]), _ = B(t[5]) - 1;
  if (n)
    return go(e, u, _) ? ho(e, u, _) : /* @__PURE__ */ new Date(NaN);
  {
    const p = /* @__PURE__ */ new Date(0);
    return !fo(e, l, s) || !zo(e, a) ? /* @__PURE__ */ new Date(NaN) : (p.setUTCFullYear(e, l, Math.max(a, s)), p);
  }
}
function B(o) {
  return o ? parseInt(o) : 1;
}
function vo(o) {
  const e = o.match(uo);
  if (!e) return NaN;
  const t = G(e[1]), n = G(e[2]), a = G(e[3]);
  return $o(t, n, a) ? t * ye + n * he + a * 1e3 : NaN;
}
function G(o) {
  return o && parseFloat(o.replace(",", ".")) || 0;
}
function yo(o) {
  if (o === "Z") return 0;
  const e = o.match(_o);
  if (!e) return 0;
  const t = e[1] === "+" ? -1 : 1, n = parseInt(e[2]), a = e[3] && parseInt(e[3]) || 0;
  return jo(n, a) ? t * (n * ye + a * he) : NaN;
}
function ho(o, e, t) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(o, 0, 4);
  const a = n.getUTCDay() || 7, l = (e - 1) * 7 + t + 1 - a;
  return n.setUTCDate(n.getUTCDate() + l), n;
}
const bo = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function ge(o) {
  return o % 400 === 0 || o % 4 === 0 && o % 100 !== 0;
}
function fo(o, e, t) {
  return e >= 0 && e <= 11 && t >= 1 && t <= (bo[e] || (ge(o) ? 29 : 28));
}
function zo(o, e) {
  return e >= 1 && e <= (ge(o) ? 366 : 365);
}
function go(o, e, t) {
  return e >= 1 && e <= 53 && t >= 0 && t <= 6;
}
function $o(o, e, t) {
  return o === 24 ? e === 0 && t === 0 : t >= 0 && t < 60 && e >= 0 && e < 60 && o >= 0 && o < 25;
}
function jo(o, e) {
  return e >= 0 && e <= 59;
}
const Po = { class: "flex flex-wrap gap-x-2 gap-y-0.5 md:gap-x-1" }, wo = ["aria-label"], te = /* @__PURE__ */ w({
  __name: "ProductTags",
  props: {
    tags: {}
  },
  setup(o) {
    const e = o;
    function t(n) {
      const a = "bg-green-600 text-white", { loyaltyProgramme: l } = Y;
      switch (n.type) {
        case "tv":
          return "bg-red-400 text-white";
        case "delivery":
          return "bg-green-600 text-white";
        case "packager":
          return "bg-green-800 text-white";
        case "action":
          return n.id === "action" ? a : "bg-yellow-500 text-gray-900";
        // special case when id does not match - then the tag has the same styling as SpecialOfferBadge
        case "loyalty-action":
          return a;
        case "new":
          return "bg-yellow-500 text-gray-900";
        case "tip":
          return "bg-yellow-100 text-yellow-900";
        case "blackfriday":
          return "bg-black text-white";
        case "recommend":
          return "bg-green-500 text-white";
        case "expiration":
          return "bg-gray-500 text-white";
        case "gift":
          return "bg-green-400 text-white";
        case "sale":
          return "bg-red-500 text-white";
        case "clearance":
          return a;
        case "advantage-package":
          return "bg-orange-400 text-white";
        case "loyalty":
          return l ? `${l.color.background} text-white` : a;
        case "savings":
          return "bg-red-100 text-red-400";
        case "otc":
          return "bg-green-100 text-green-700";
        default:
          return a;
      }
    }
    return (n, a) => (c(), d("ul", Po, [
      r("li", {
        "aria-label": n.$t("general_tags"),
        class: "sr-only"
      }, null, 8, wo),
      (c(!0), d(g, null, V(e.tags, (l, s) => (c(), d("li", {
        key: s,
        class: $([
          t(l),
          "rounded-lg px-2 py-1",
          "text-nowrap text-[11px] font-bold uppercase leading-none"
        ])
      }, m(l.label), 3))), 128))
    ]));
  }
}), xo = { class: "mb-2 text-mobile-body-m font-bold text-secondary-700 sm:text-desktop-body-m" }, qo = { class: "mb-1 md:mb-0" }, So = ["onClick"], No = ["checked", "id"], Do = { class: "text-mobile-body-m font-normal text-secondary-700 sm:text-desktop-body-m" }, Vo = { class: "flex flex-wrap gap-2" }, Co = { class: "text-mobile-body-m font-bold sm:text-desktop-body-m" }, Eo = ["textContent"], le = /* @__PURE__ */ w({
  __name: "ProductAlternatives",
  props: {
    mainProductId: {},
    title: {},
    products: {}
  },
  setup(o) {
    const e = o;
    function t(a) {
      return "quantity" in a;
    }
    function n(a) {
      const l = new URL(window.location.href);
      l.pathname = `/${a}`, window.location.href = l.toString();
    }
    return (a, l) => (c(), d("div", null, [
      r("h2", xo, m(e.title), 1),
      r("div", qo, [
        (c(!0), d(g, null, V(e.products, (s) => (c(), d("label", {
          key: s.id,
          class: $([
            "mb-2 p-4",
            "flex items-center gap-2",
            "cursor-pointer rounded-md border",
            s.id === e.mainProductId ? "border-secondary-500" : "border-secondary-200"
          ]),
          onClick: (u) => n(s.alias)
        }, [
          r("input", {
            type: "radio",
            checked: s.id === e.mainProductId,
            name: "variant",
            id: s.id,
            class: "m-0.5 size-5 shrink-0 cursor-pointer appearance-none rounded-full border border-secondary-300 checked:border-[6px] checked:border-primary-500"
          }, null, 8, No),
          h(H, {
            image: s.image,
            "image-size": "product-128x128-webp",
            class: "size-16 object-contain"
          }, null, 8, ["image"]),
          r("div", null, [
            r("h3", Do, m(s.name), 1),
            r("div", Vo, [
              r("span", Co, m(i(L)(s.price.price)), 1),
              t(s) ? (c(), d(g, { key: 0 }, [
                r("span", {
                  textContent: m(`${i(L)(s.price.price / s.quantity)}/${a.$t("general_piece")}`),
                  class: "text-desktop-body-m text-gray-400"
                }, null, 8, Eo),
                s.price.showDiscount && s.price.rrpPrice ? (c(), N(te, {
                  key: 0,
                  tags: [
                    {
                      label: a.$t("save_amount_notification", {
                        amount: i(L)(s.price.rrpPrice - s.price.price)
                      }),
                      id: "savings",
                      type: "savings"
                    }
                  ]
                }, null, 8, ["tags"])) : y("", !0)
              ], 64)) : y("", !0)
            ])
          ])
        ], 10, So))), 128))
      ])
    ]));
  }
});
function Mo(o, e = { delay: 0, onMounted: !1 }) {
  Me(() => {
    e.onMounted && o();
  }), oo(window, "resize", to(o, e.delay));
}
const Uo = { class: "@container" }, Ao = { class: "mb-3 text-mobile-headline-l font-bold @sm:mb-2 sm:text-desktop-headline-m" }, To = ["onClick"], Ro = {
  class: /* @__PURE__ */ $([
    "w-full rounded-full px-6 py-3.5 @sm:py-2",
    "border border-primary-300 bg-primary-100 text-secondary-700 transition-colors",
    "text-mobile-body-l @sm:text-desktop-body-l",
    "hover:border-primary-500 hover:bg-primary-500 hover:text-white",
    "focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-primary-500",
    "active:ring-1 active:ring-primary-800"
  ])
}, Zo = /* @__PURE__ */ w({
  __name: "ProductCategories",
  props: {
    categories: {}
  },
  setup(o) {
    const e = o;
    function t(u) {
      ee(u);
    }
    const n = pe("listElement"), a = D(!0), l = D();
    function s() {
      a.value = !0, Ue(() => {
        if (!n.value) return;
        const { clientHeight: u, scrollHeight: _ } = n.value;
        l.value = u >= _;
      });
    }
    return Mo(s, { delay: 100, onMounted: !0 }), (u, _) => (c(), d("div", Uo, [
      r("h2", Ao, m(u.$t("take_a_look_also_at_following_categories")), 1),
      r("ul", {
        ref_key: "listElement",
        ref: n,
        class: $([
          "-mx-1 mb-3 p-1 @sm:mb-1 @lg:mb-7",
          "flex flex-col gap-3 @sm:flex-row @sm:flex-wrap",
          "overflow-y-hidden transition-[max-height] duration-500 ease-in-out",
          a.value ? "max-h-32 @sm:max-h-28" : "max-h-min"
        ]),
        style: "interpolate-size: allow-keywords"
      }, [
        (c(!0), d(g, null, V(e.categories, (p, j) => (c(), d("li", {
          key: j,
          onClick: (P) => t(p.alias)
        }, [
          r("button", Ro, m(p.name), 1)
        ], 8, To))), 128))
      ], 2),
      l.value ? y("", !0) : (c(), d("div", {
        key: 0,
        class: $(["flex items-center", "cursor-pointer text-mobile-body-l text-primary-500 @sm:text-desktop-body-m"]),
        onClick: _[0] || (_[0] = (p) => a.value = !a.value)
      }, [
        X(m(a.value ? u.$t("show_more") : u.$t("show_less")) + " ", 1),
        r("span", {
          class: $(["iconify-[mdi--chevron-down]", "size-4", !a.value && "rotate-180"])
        }, null, 2)
      ]))
    ]));
  }
}), Lo = "Hodnocení", Bo = "Nechte si u lékaře vystavit ePoukaz", Oo = "Váš lékař vám vystaví ePoukaz na léčebnou nebo ortopedickou pomůcku a sdělí vám její 9místný identifikátor formou SMS zprávy, e-mailem nebo tištěného poukazu.", Io = "Vložte kód ePoukazu", Fo = "Do webového formuláře nebo v BENU aplikaci v záložce ePoukaz, zadejte 9místný kód z ePoukazu vypsáním, naskenováním QR kódu přes kameru nebo jej vyberte z galerie", Jo = "My ověříme jeho platnost a zobrazíme zdravotnické pomůcky předepsané lékařem.", Ko = "Vyberte množství a přidejte produkty z ePoukazu do košíku", Qo = "Na detailu produktu upravte požadované množství zdravotnické pomůcky, vložte do košíku a podle přání přidejte i ostatní zboží.", Ho = "Nechte si zdravotnické pomůcky doručit až domů", Wo = "V košíku vyberte místo doručení, typ dopravy a plaťte vámi preferovaným způsobem. My vám zboží doručíme jako běžnou zásilku z e-shopu na vámi vybrané místo, v bezpečném a diskrétním balení. Vy se můžete těšit na svou objednávku a také sledovat její stav v aplikaci či na webu benu.cz", Yo = "Pohodlně z domova", Go = "Objednejte si svůj ePoukaz, když ho potřebujete, a to stejným způsobem jako zboží z e-shopu.", Xo = "Doručení přímo k vám", et = "Zajistíme bezpečné doručení zdravotnických prostředků z ePoukazu přímo k vašim dveřím nebo do vaší oblíbené lékárny.", ot = "Doprava ZDARMA", tt = "Uplatněte si ePoukaz na BENU.cz a náklady za dopravu uhradíme za vás.", nt = "Kompletní odborná podpora", at = "Naši farmaceuti vám pomohou s výběrem a rovněž vám rádi zodpoví dotazy na sortiment a použití zdravotnických prostředků.", rt = "Vše najednou", it = "Spolu s ePoukazem můžete jednoduše přidat do nákupního košíku i další vybrané produkty z e-shopu a nechat si doručit vše dohromady.", st = "Bezpečnost a diskrétnost", ct = "Při nákupech u nás si můžete být jisti, že vám poskytneme bezpečné a diskrétní prostředí pro zajištění maximální spokojenosti.", lt = "Jak ePoukaz funguje?", dt = "Jak {eVoucherInflection} funguje?", ut = "Proč uplatnit {eVoucherInflection} online?", _t = "Co je {eVoucherInflection}?", pt = "Co je to ePoukaz?", mt = "ePoukaz nebo Poukaz je forma lékařského předpisu na léčebnou nebo ortopedickou pomůcku předepisovanou lékařem. Lze na něj předepsat různé typy zdravotnických prostředků, jako například inkontinenční či stomické pomůcky, pomůcky na monitoring glukózy nebo obvazový materiál.", kt = "Poukaz vystavený elektronicky je ePoukaz. Jeho součástí je 9místný alfanumerický identifikátor, který můžete obdržet formou SMS, e-mailem nebo i jako tištěnou průvodku. Jeho platnost je 30 dní a může se na něj vztahovat plná nebo částečná úhrada zdravotní pojišťovny.", vt = "Jaké Poukazy nelze vydat ONLINE na BENU.cz?", yt = "Online nelze objednat zdravotnické prostředky na papírový poukaz nebo pomůcky aplikované pod dozorem zdravotníka (sluchadla, injekčně aplikované přípravky, dioptrické brýle apod.) či přístroje nadměrných velikostí (invalidní vozíky apod.)", ht = "Slyšeli jste už o elektronické formě lékařského předpisu na léčebnou a ortopedickou pomůcku?", bt = "Obsahuje váš tištěný poukaz 9místný kód a QR kód?", ft = "Váš poukaz lze uplatnit elektronicky.", zt = "Ano", gt = "Ne, neobsahuje tyto údaje.", $t = "Váš poukaz bohužel nelze uplatnit elektronicky. Uplatněte jej v lékárně, nebo nakupte zdravotnické pomůcky bez poukazu na e-shopu.", jt = "Najít BENU lékárnu", Pt = "Nakupovat zdravotnické pomůcky", wt = "elektronický", xt = "tištěný", qt = "Mám {form} poukaz", St = "Lékař mi poslal SMS či e-mail s předpisem na zdravotnickou pomůcku.", Nt = "Nemám poukaz, ale chci nakoupit {medicalEquipments}", Dt = "Nakupujte oblíbené produkty za standardní ceny bez poukazu na našem e-shopu.", Vt = "zdravotnické pomůcky", Ct = "Jak objednat {medicalEquipments}?", Et = "Máte od lékaře Poukaz na léčebnou nebo ortopedickou pomůcku? Své předepsané pomůcky si na BENU.cz můžete objednat ZDARMA až domů!", Mt = "Elektronický poukaz na léčebnou a ortopedickou pomůcku", Ut = "Zdravotnické pomůcky na {eVoucherInflection} doručíme až domů", At = "Objednání předepsaných zdravotnických prostředků lékařem nyní vyřešíte z pohodlí domova! Jednoduše si uplatněte svůj ePoukaz online, do košíku přihoďte i další zboží z e-shopu a my vám vše dovezeme na vámi vybranou adresu.", Tt = "Vložit kód ePoukazu", Rt = "Nejčastější dotazy k {eVoucherInflection}", Zt = "ePoukaz", Lt = "ePoukazu", Bt = "Máte už mobilní aplikaci?", Ot = "S naší mobilní aplikací snadno zjistíte stav vaší objednávky, zarezervujete vyzvednutí eReceptu a budete mít náš e-shop vždy po ruce.", It = "Objevte další služby, které poskytuje vaše BENU Lékárna", Ft = "Rezervovat eRecept", Jt = "Zjistit dostupnost léků", Kt = "Online poradna", Qt = "Články o zdraví", Ht = "Potřebujete poradit?", Wt = "info{'@'}benu.cz", Yt = "212 812 812", Gt = 'Volejte Po-Pá od 8.00 do 17.00 nebo pište na <a href="mailto:{support_email}">{support_email}</a>.', Xt = "Uplatnit ePoukaz", en = "Zadejte 9místný kód ePoukazu", on = "Kód ePoukazu najdete na tištěné průvodce od lékaře, v SMS nebo v e-mailové zprávě.", tn = "Potvrdit", nn = "ePoukaz {ePrescriptionCode}", an = "Platnost do {expirationDate}", rn = "Platnost expirovala {expirationDate}", sn = "Hledáme pro vás ePoukaz", cn = "Nechte si produkty doručit pohodlně až domů!", ln = 'Lékařem předepsáno <span style="font-weight: 700">{quantity}</span> kusů | Lékařem předepsán <span style="font-weight: 700">{quantity}</span> kus | Lékařem předepsány <span style="font-weight: 700">{quantity}</span> kusy', dn = "{quantity} kusů | {quantity} kus | {quantity} kusy", un = "SUKL kód", _n = "Zpět na e-shop", pn = "Zadat nový ePoukaz", mn = "Váš ePoukaz je po době platnosti!", kn = "Váš ePoukaz expiroval {expirationDate}. Pokud produkt stále potřebujete, požádejte svého lékaře o vystavení nového kódu ePoukazu nebo si své pomůcky můžete volně nakoupit na BENU e-shopu za standardní ceny.", vn = "Tento ePoukaz je již plně vyčerpaný!", yn = "Tento ePoukaz byl už plně uplatněn. Pokud tyto zdravotnické pomůcky stále potřebujete, požádejte svého lékaře o nový ePoukaz nebo si je můžete volně nakoupit na BENU e-shope za standardní ceny.", hn = "Produkt není skladem. Nastavte si Hlídacího psa!", bn = "Hlídací pes je služba, která vám umožní sledovat skladovou dostupnost u vámi vybraného, nedostupného zboží. Stačí zadat vaši e-mailovou adresu a při opětovném naskladnění zboží vám pošleme upozornění e-mailovou zprávou.", fn = "Váš ePoukaz brzy expiruje!", zn = "Platnost vašeho ePoukazu je kratší něž 1 PRACOVNÍ DEN. Vzhledem k omezené otevírací době lékárny a potřebě přítomnosti farmaceuta, nejsme schopni připravit a odeslat vaše zdravotnické pomůcky včas. Pro jejich uplatnění navštivte prosím kamennou lékárnu nebo specializovanou prodejnu. Děkujeme za pochopení.", gn = "Tuto pomůcku nelze vydat online!", $n = "Zdravotnický prostředek tohoto typu vyžaduje dozor zdravotnického pracovníka, individuální přístup nebo ho z dalších legislativních důvodů nelze vydat online. Obraťte se prosím na specializovanou prodejnu zdravotnických potřeb.", jn = "Tuto zdravotnickou pomůcku zatím neumíme vydat online!", Pn = "Jedná se o produkt, který vyžaduje osobní konzultaci nebo individuální přístup. Pro její uplatnění navštivte prosím kamennou BENU Lékárnu. Děkujeme za pochopení.", wn = "Váš ePoukaz byl již vydán nebo čeká na doplnění informací od lékaře.", xn = "V tuto chvíli nemůžeme ePoukaz zpracovat. Pokud potřebujete zdravotnické pomůcky, obraťte se na svého lékaře.", qn = "Váš ePoukaz je označen jako připravovaný v BENU Lékárně K Pérovně 945/7 a aktuálně se zpracovává.", Sn = "Pro více informací se obraťte na naši zákaznickou linku 212 812 812.", Nn = "Dejte mi vědět", Dn = "Vaše e-mailová adresa", Vn = "E-mailová adresa je povinná", Cn = "Zadejte platnou e-mailovou adresu", En = "Hlídací pes byl úspěšně nastaven", Mn = "Nastala chyba při nastavování Hlídacího psa", Un = "Najít nejbližší BENU Lékárnu", An = "Seznam specializovaných prodejen", Tn = "Shrnutí ePoukazu", Rn = "Cena", Zn = "Úhrada pojišťovny", Ln = "Váš doplatek", Bn = "{amount} Kč", On = "Vložit do košíku", In = "Pomůcka vyžadující osobní konzultaci", Fn = "Pomůcku nelze vydat online", Jn = "Skladem na e-shopu", Kn = "Nedostupný", Qn = "Vložit další ePoukaz", Hn = "Vložili jste produkt z ePoukazu do košíku!", Wn = "Díky ePoukazu máte dopravu {price}", Yn = "zdarma", Gn = "Pokračovat do košíku", Xn = "Děkujeme a těšíme se na Vás!", ea = "Vaše rezervace č. {orderNumber} byla odeslána", oa = "Potvrzení rezervace jsme odeslali na e-mail a.ahmad{'@'}benu.cz. Jakmile bude váš balíček přípraven k vyzvednutí na pobočce K Pérovně, Praha 9 (dnes otevřeno 9-19 hod), pošleme vám SMS a e-mail. Hned potom můžete vyrazit pro svou objednávku.", ta = "Vytisknout shrnutí objednávky", na = "Mohlo by vás zajímat", aa = "Přidat do košíku", ra = "Potřebujete si vyzvednout léky z eReceptu?", ia = "Množství", sa = "Zobrazit méně", ca = "Zobrazit více", la = "Více o ePoukazu", da = "Bohužel, zadaný kód ePoukazu jsme nenalezli.", ua = 'Zadali jste kód eReceptu, pro jeho uplatnění pokračujte na stránku <a href="{link}">www.benunapredpis.cz</a>', _a = "Uplatněte ePoukaz", pa = "Zadat kód ručně", ma = "Naskenovat QR kód", ka = "Vybrat QR kód z galerie", va = "Při objednání menšího množství, než vám předepsal lékař, zůstane váš ePoukaz platný do vyčerpání všech předepsaných kusů nebo do konce jeho platnosti.", ya = "Něco se pokazilo.", ha = "Zkuste to znovu prosím!", ba = "Načíst znovu", fa = "Máte neuložené změny.", za = "Opravdu chcete ePoukaz opustit?", ga = "Zpět", $a = "Pokračovat", ja = "Při přidávání produktu do košíku došlo k chybě. Zkuste to prosím znovu.", Pa = "Opustit", wa = "Momentálně nedostupné", xa = "Nedostupný produkt", qa = "Samostatně neprodejné", Sa = "Prodej byl již ukončen", Na = "Již brzy", Da = "z", Va = "Zobrazit obrazek {imageNumber}", Ca = "Štítky", Ea = "Přidat do oblíbených", Ma = "Více", Ua = "Další varianty", Aa = "Kupte více kusů a získáte lepší cenu za balení", Ta = "Cena za {unitText} v balení:", Ra = "Snížit množství ke koupi", Za = "Zvýšit množství ke koupi", La = "Koupit", Ba = "Galerie obrázků produktu", Oa = "Zobrazit galerii", Ia = "Předchozí obrázek", Fa = "Další obrázek", Ja = "Zobrazit vše", Ka = "Ušetříte {amount}", Qa = "Nastavte si hlídacího psa", Ha = "Prohlédněte si také", Wa = "Zašleme vám e-mail, jakmile bude tato položka opět skladem.", Ya = "Nastavili jsme vám hlídacího psa.", Ga = "Internetová cena", Xa = "Internetová cena - co je tím myšleno?", er = "Skladem na e-shopu", or = "Osobní odběr na lékárně ZDARMA", tr = "K vyzvednutí na lékárně <span class='text-primary-500'>ihned ZDARMA</span>", nr = "K vyzvednutí ihned", ar = "Vyberte lékárnu", rr = "kus", ir = "ks", sr = "Zadaný ePoukaz je již načten v košíku.", cr = "Nepodařilo se načíst detail produktu.", lr = "Souhlasím s {link}", dr = "podmínkami kontaktování", ur = "Souhlas s kontaktováním je nutné potvrdit", _r = "Doručení k vám již", pr = "K vyzvednutí již", mr = "K vyzdvihnutí na lékárně již", kr = "Všechny možnosti doručení", vr = "Osobní odběr", yr = "Doručení k vám", hr = "Ihned", br = "Dnes", fr = "Zítra", zr = "od", gr = {
  general_reviews: Lo,
  issue_medical_voucher: Bo,
  voucher_details_explanation: Oo,
  enter_voucher_code: Io,
  voucher_code_entry_instruction: Fo,
  voucher_code_entry_instruction_verification: Jo,
  select_quantity_and_add_products: Ko,
  product_quantity_selection_instruction: Qo,
  arrange_home_delivery: Ho,
  home_delivery_selection_instruction: Wo,
  comfort_from_home: Yo,
  order_your_voucher: Go,
  direct_delivery: Xo,
  secure_delivery_explanation: et,
  free_shipping: ot,
  free_shipping_explanation: tt,
  complete_professional_support: nt,
  pharmacist_support_details: at,
  all_at_once: rt,
  all_at_once_explanation: it,
  safety_and_discretion: st,
  safety_and_discretion_explanation: ct,
  eprescription_how_it_works: lt,
  eprescription_how_it_works_colored: dt,
  why_use_eprescription: ut,
  what_is_eprescription_colored: _t,
  what_is_eprescription: pt,
  eprescription_info: mt,
  eprescription_info_electronic: kt,
  eprescription_disabled_title: vt,
  eprescription_disabled_info: yt,
  have_you_heard_about_electronic_prescription: ht,
  does_voucher_include_code_and_qr: bt,
  voucher_can_be_redeemed_electronically: ft,
  yes: zt,
  no_does_not_include_information: gt,
  voucher_cannot_be_redeemed_electronically: $t,
  find_benu_pharmacy: jt,
  shop_medical_equipments: Pt,
  electronic_form: wt,
  printed_form: xt,
  eprescription_have_form: qt,
  received_eprescription: St,
  without_eprescription: Nt,
  buy_medical_equipments: Dt,
  medical_equipments: Vt,
  medical_equipments_how_to_order: Ct,
  medical_equipments_info: Et,
  eprescription_info_subtitle: Mt,
  eprescription_info_title: Ut,
  eprescription_info_description: At,
  eprescription_input_code: Tt,
  faq_title: Rt,
  eprescription_nominativ: Zt,
  eprescription_genitiv: Lt,
  app_banner_title: Bt,
  app_banner_description: Ot,
  crossroad_title: It,
  crossroad_reservation: Ft,
  crossroad_availability: Jt,
  crossroad_online_support: Kt,
  crossroad_health_articles: Qt,
  support_title: Ht,
  support_email: Wt,
  support_phone_number: Yt,
  support_info: Gt,
  apply_eprescription: Xt,
  enter_eprescription_code: en,
  eprescription_code_location: on,
  confirm: tn,
  e_prescription_label: nn,
  expire_at: an,
  expired_already: rn,
  eprescription_searching: sn,
  delivery_to_bed: cn,
  prescribed_quantity: ln,
  pieces: dn,
  sukl_code: un,
  eshop_back: _n,
  eprescription_enter_new_code: pn,
  alert_expired_title: mn,
  alert_expired_message: kn,
  alert_fully_used_title: vn,
  alert_fully_used_message: yn,
  alert_out_of_stock_title: hn,
  alert_out_of_stock_message: bn,
  alert_soon_to_be_expired_title: fn,
  alert_soon_to_be_expired_message: zn,
  alert_forbidden_product_title: gn,
  alert_forbidden_product_message: $n,
  alert_personal_check_required_title: jn,
  alert_personal_check_required_message: Pn,
  alert_unknown_product_title: wn,
  alert_unknown_product_message: xn,
  alert_blocked_title: qn,
  alert_blocked_message: Sn,
  let_me_know: Nn,
  email_placeholder: Dn,
  email_required: Vn,
  email_invalid: Cn,
  watch_dog_success: En,
  watch_dog_error: Mn,
  "buy_product_on_e-shop": "Zobrazit produkt na e-shopu",
  search_for_closest_pharmacy: Un,
  list_of_specialized_stores: An,
  eprescription_summary: Tn,
  general_price: Rn,
  insurance_coverage: Zn,
  your_contribution: Ln,
  amount_due: Bn,
  add_to_basket: On,
  require_in_person_consultation: In,
  cannot_be_issued_online: Fn,
  product_in_stock: Jn,
  product_out_of_stock: Kn,
  eprescription_insert_next: Qn,
  prebasket_item_insert_notification: Hn,
  prebasket_delivery: Wn,
  general_free: Yn,
  continue_to_basket: Gn,
  thank_you_message: Xn,
  reservation_sent: ea,
  reservation_confirmation: oa,
  print_order_summary: ta,
  you_may_be_interested: na,
  add_to_cart: aa,
  pickup_meds_from_erecept: ra,
  quantity: ia,
  show_less: sa,
  show_more: ca,
  eprescription_more_about: la,
  eprescription_code_not_found: da,
  rx_reservation_code_submitted: ua,
  redeem_voucher: _a,
  enter_code_manually: pa,
  scan_qr_code: ma,
  select_qr_code_from_gallery: ka,
  eprescription_quantity_warning: va,
  error_something_went_wrong: ya,
  try_again: ha,
  load_again: ba,
  unsaved_changes: fa,
  eprescription_leave_question: za,
  general_back: ga,
  general_continue: $a,
  add_to_cart_error: ja,
  general_leave: Pa,
  general_unavailable: wa,
  general_unavailable_product: xa,
  not_for_sale_separately: qa,
  archived_product: Sa,
  pre_order_product: Na,
  general_out_of: Da,
  go_to_image: Va,
  general_tags: Ca,
  toggle_favourite: Ea,
  general_more: Ma,
  product_variants_title: Ua,
  product_bundles_title: Aa,
  unit_price_label: Ta,
  general_decrease_quantity: Ra,
  general_increase_quantity: Za,
  general_buy: La,
  product_detail_gallery: Ba,
  show_gallery: Oa,
  previous_image: Ia,
  next_image: Fa,
  show_all_images: Ja,
  save_amount_notification: Ka,
  watch_dog_setup_prompt: Qa,
  take_a_look_also_at_following_categories: Ha,
  watch_dog_stock_email_info: Wa,
  watch_dog_setup_confirmation: Ya,
  internet_price: Ga,
  internet_price_tooltip: Xa,
  in_stock_on_e_shop: er,
  free_pickup_on_pharmacy: or,
  immediate_pickup: tr,
  otc_tag: nr,
  choose_pharmacy: ar,
  general_piece: rr,
  general_piece_abbr: ir,
  eprescription_already_loaded: sr,
  failed_to_load_product_detail_data: cr,
  general_i_agree_with: lr,
  watchdog_consent_terms_conditions: dr,
  watchdog_consent_required: ur,
  carrier_delivery_to_you: _r,
  pickup_delivery_to_you: pr,
  pickup_delivery_to_you_pharmacy: mr,
  all_delivery_options: kr,
  personal_pickup: vr,
  carrier_delivery: yr,
  date_immediately: hr,
  date_today: br,
  date_tomorrow: fr,
  from: zr
}, $r = "Recenzii", jr = "Nechte si u lékaře vystavit ePoukaz", Pr = "Váš lékař vám vystaví ePoukaz na léčebnou nebo ortopedickou pomůcku a sdělí vám její 9místný identifikátor formou SMS zprávy, e-mailem nebo tištěného poukazu.", wr = "Vložte kód ePoukazu", xr = "Do webového formuláře nebo v BENU aplikaci v záložce ePoukaz, zadejte 9místný kód z ePoukazu vypsáním, naskenováním QR kódu přes kameru nebo jej vyberte z galerie", qr = "My ověříme jeho platnost a zobrazíme zdravotnické pomůcky předepsané lékařem.", Sr = "Vyberte množství a přidejte produkty z ePoukazu do košíku", Nr = "Na detailu produktu upravte požadované množství zdravotnické pomůcky, vložte do košíku a podle přání přidejte i ostatní zboží.", Dr = "Nechte si zdravotnické pomůcky doručit až domů", Vr = "V košíku vyberte místo doručení, typ dopravy a plaťte vámi preferovaným způsobem. My vám zboží doručíme jako běžnou zásilku z e-shopu na vámi vybrané místo, v bezpečném a diskrétním balení. Vy se můžete těšit na svou objednávku a také sledovat její stav v aplikaci či na webu benu.cz", Cr = "Pohodlně z domova", Er = "Objednejte si svůj ePoukaz, když ho potřebujete, a to stejným způsobem jako zboží z e-shopu.", Mr = "Doručení přímo k vám", Ur = "Zajistíme bezpečné doručení zdravotnických prostředků z ePoukazu přímo k vašim dveřím nebo do vaší oblíbené lékárny.", Ar = "Doprava ZDARMA", Tr = "Uplatněte si ePoukaz na BENU.cz a náklady za dopravu uhradíme za vás.", Rr = "Kompletní odborná podpora", Zr = "Naši farmaceuti vám pomohou s výběrem a rovněž vám rádi zodpoví dotazy na sortiment a použití zdravotnických prostředků.", Lr = "Vše najednou", Br = "Spolu s ePoukazem můžete jednoduše přidat do nákupního košíku i další vybrané produkty z e-shopu a nechat si doručit vše dohromady.", Or = "Bezpečnost a diskrétnost", Ir = "Při nákupech u nás si můžete být jisti, že vám poskytneme bezpečné a diskrétní prostředí pro zajištění maximální spokojenosti.", Fr = "Jak ePoukaz funguje?", Jr = "Jak {eVoucherInflection} funguje?", Kr = "Proč uplatnit {eVoucherInflection} online?", Qr = "Co je {eVoucherInflection}?", Hr = "Co je to ePoukaz?", Wr = "ePoukaz nebo Poukaz je forma lékařského předpisu na léčebnou nebo ortopedickou pomůcku předepisovanou lékařem. Lze na něj předepsat různé typy zdravotnických prostředků, jako například inkontinenční či stomické pomůcky, pomůcky na monitoring glukózy nebo obvazový materiál.", Yr = "Poukaz vystavený elektronicky je ePoukaz. Jeho součástí je 9místný alfanumerický identifikátor, který můžete obdržet formou SMS, e-mailem nebo i jako tištěnou průvodku. Jeho platnost je 30 dní a může se na něj vztahovat plná nebo částečná úhrada zdravotní pojišťovny.", Gr = "Jaké Poukazy nelze vydat ONLINE na BENU.cz?", Xr = "Online nelze objednat zdravotnické prostředky na papírový poukaz nebo pomůcky aplikované pod dozorem zdravotníka (sluchadla, injekčně aplikované přípravky, dioptrické brýle apod.) či přístroje nadměrných velikostí (invalidní vozíky apod.)", ei = "Slyšeli jste už o elektronické formě lékařského předpisu na léčebnou a ortopedickou pomůcku?", oi = "Obsahuje váš tištěný poukaz 9místný kód a QR kód?", ti = "Váš poukaz lze uplatnit elektronicky.", ni = "Ano", ai = "Ne, neobsahuje tyto údaje.", ri = "Váš poukaz bohužel nelze uplatnit elektronicky. Uplatněte jej v lékárně, nebo nakupte zdravotnické pomůcky bez poukazu na e-shopu.", ii = "Najít BENU lékárnu", si = "Nakupovat zdravotnické pomůcky", ci = "elektronický", li = "tištěný", di = "Mám {form} poukaz", ui = "Lékař mi poslal SMS či e-mail s předpisem na zdravotnickou pomůcku.", _i = "Nemám poukaz, ale chci nakoupit {medicalEquipments}", pi = "Nakupujte oblíbené produkty za standardní ceny bez poukazu na našem e-shopu.", mi = "zdravotnické pomůcky", ki = "Jak objednat {medicalEquipments}?", vi = "Máte od lékaře Poukaz na léčebnou nebo ortopedickou pomůcku? Své předepsané pomůcky si na BENU.cz můžete objednat ZDARMA až domů!", yi = "Elektronický poukaz na léčebnou a ortopedickou pomůcku", hi = "Zdravotnické pomůcky na {eVoucherInflection} doručíme až domů", bi = "Objednání předepsaných zdravotnických prostředků lékařem nyní vyřešíte z pohodlí domova! Jednoduše si uplatněte svůj ePoukaz online, do košíku přihoďte i další zboží z e-shopu a my vám vše dovezeme na vámi vybranou adresu.", fi = "Vložit kód ePoukazu", zi = "Nejčastější dotazy k {eVoucherInflection}", gi = "ePoukaz", $i = "ePoukazu", ji = "Máte už mobilní aplikaci?", Pi = "S naší mobilní aplikací snadno zjistíte stav vaší objednávky, zarezervujete vyzvednutí eReceptu a budete mít náš e-shop vždy po ruce.", wi = "Objevte další služby, které poskytuje vaše BENU Lékárna", xi = "Rezervovat eRecept", qi = "Zjistit dostupnost léků", Si = "Online poradna", Ni = "Články o zdraví", Di = "Potřebujete poradit?", Vi = "info{'@'}benu.cz", Ci = "212 812 812", Ei = 'Volejte Po-Pá od 8.00 do 17.00 nebo pište na <a href="mailto:{support_email}">{support_email}</a>.', Mi = "Uplatnit ePoukaz", Ui = "Zadejte 9místný kód ePoukazu", Ai = "Kód ePoukazu najdete na tištěné průvodce od lékaře, v SMS nebo v e-mailové zprávě.", Ti = "Potvrdit", Ri = "ePoukaz {ePrescriptionCode}", Zi = "Platnost do {expirationDate}", Li = "Platnost expirovala {expirationDate}", Bi = "Hledáme pro vás ePoukaz", Oi = "Nechte si produkty doručit pohodlně až domů!", Ii = 'Lékařem předepsáno <span style="font-weight: 700">{quantity}</span> kusů | Lékařem předepsán <span style="font-weight: 700">{quantity}</span> kus | Lékařem předepsány <span style="font-weight: 700">{quantity}</span> kusy', Fi = "{quantity} kusů | {quantity} kus | {quantity} kusy", Ji = "SUKL kód", Ki = "Zpět na e-shop", Qi = "Zadat nový ePoukaz", Hi = "Váš ePoukaz je po době platnosti!", Wi = "Váš ePoukaz expiroval {expirationDate}. Pokud produkt stále potřebujete, požádejte svého lékaře o vystavení nového kódu ePoukazu nebo si své pomůcky můžete volně nakoupit na BENU e-shopu za standardní ceny.", Yi = "Tento ePoukaz je již plně vyčerpaný!", Gi = "Tento ePoukaz byl už plně uplatněn. Pokud tyto zdravotnické pomůcky stále potřebujete, požádejte svého lékaře o nový ePoukaz nebo si je můžete volně nakoupit na BENU e-shope za standardní ceny.", Xi = "Produkt není skladem. Nastavte si Hlídacího psa!", es = "Hlídací pes je služba, která vám umožní sledovat skladovou dostupnost u vámi vybraného, nedostupného zboží. Stačí zadat vaši e-mailovou adresu a při opětovném naskladnění zboží vám pošleme upozornění e-mailovou zprávou.", os = "Váš ePoukaz brzy expiruje!", ts = "Platnost vašeho ePoukazu je kratší něž 1 PRACOVNÍ DEN. Vzhledem k omezené otevírací době lékárny a potřebě přítomnosti farmaceuta, nejsme schopni připravit a odeslat vaše zdravotnické pomůcky včas. Pro jejich uplatnění navštivte prosím kamennou lékárnu nebo specializovanou prodejnu. Děkujeme za pochopení.", ns = "Tuto pomůcku nelze vydat online!", as = "Zdravotnický prostředek tohoto typu vyžaduje dozor zdravotnického pracovníka, individuální přístup nebo ho z dalších legislativních důvodů nelze vydat online. Obraťte se prosím na specializovanou prodejnu zdravotnických potřeb.", rs = "Tuto zdravotnickou pomůcku zatím neumíme vydat online!", is = "Jedná se o produkt, který vyžaduje osobní konzultaci nebo individuální přístup. Pro její uplatnění navštivte prosím kamennou BENU Lékárnu. Děkujeme za pochopení.", ss = "Váš ePoukaz byl již vydán nebo čeká na doplnění informací od lékaře.", cs = "V tuto chvíli nemůžeme ePoukaz zpracovat. Pokud potřebujete zdravotnické pomůcky, obraťte se na svého lékaře.", ls = "Váš ePoukaz je označen jako připravovaný v BENU Lékárně K Pérovně 945/7 a aktuálně se zpracovává.", ds = "Pro více informací se obraťte na naši zákaznickou linku 212 812 812.", us = "Spune-mi", _s = "Adresa ta de email", ps = "Adresa de email este necesara", ms = "Introdu o adresa de email valida", ks = "Câinele de pază a fost înființat cu succes", vs = "A aparut o eroare la configurarea Watchdog", ys = "Najít nejbližší BENU Lékárnu", hs = "Seznam specializovaných prodejen", bs = "Shrnutí ePoukazu", fs = "Cena", zs = "Úhrada pojišťovny", gs = "Váš doplatek", $s = "{amount} Kč", js = "Vložit do košíku", Ps = "Pomůcka vyžadující osobní konzultaci", ws = "Pomůcku nelze vydat online", xs = "Skladem na e-shopu", qs = "Nedostupný", Ss = "Vložit další ePoukaz", Ns = "Vložili jste produkt z ePoukazu do košíku!", Ds = "Díky ePoukazu máte dopravu {price}", Vs = "zdarma", Cs = "Pokračovat do košíku", Es = "Děkujeme a těšíme se na Vás!", Ms = "Vaše rezervace č. {orderNumber} byla odeslána", Us = "Potvrzení rezervace jsme odeslali na e-mail a.ahmad{'@'}benu.cz. Jakmile bude váš balíček přípraven k vyzvednutí na pobočce K Pérovně, Praha 9 (dnes otevřeno 9-19 hod), pošleme vám SMS a e-mail. Hned potom můžete vyrazit pro svou objednávku.", As = "Vytisknout shrnutí objednávky", Ts = "Mohlo by vás zajímat", Rs = "Přidat do košíku", Zs = "Potřebujete si vyzvednout léky z eReceptu?", Ls = "Množství", Bs = "Vizualizați mai puțin", Os = "Vizualizați mai multe", Is = "Více o ePoukazu", Fs = "Bohužel, zadaný kód ePoukazu jsme nenalezli.", Js = 'Zadali jste kód eReceptu, pro jeho uplatnění pokračujte na stránku <a href="{link}">www.benunapredpis.cz</a>', Ks = "Uplatněte ePoukaz", Qs = "Zadat kód ručně", Hs = "Naskenovat QR kód", Ws = "Vybrat QR kód z galerie", Ys = "Při objednání menšího množství, než vám předepsal lékař, zůstane váš ePoukaz platný do vyčerpání všech předepsaných kusů nebo do konce jeho platnosti.", Gs = "Něco se pokazilo.", Xs = "Zkuste to znovu prosím!", ec = "Načíst znovu", oc = "Máte neuložené změny.", tc = "Opravdu chcete ePoukaz opustit?", nc = "Zpět", ac = "Pokračovat", rc = "Při přidávání produktu do košíku došlo k chybě. Zkuste to prosím znovu.", ic = "Opustit", sc = "Momentan indisponibil", cc = "Produs indisponibil", lc = "Nu se vinde separat", dc = "de la", uc = "Vezi imaginea {imageNumber}", _c = "Etichete", pc = "Přidat do oblíbených", mc = "Mai multe", kc = "Alte variante", vc = "Cumpara mai mult si obtine un pret mai bun", yc = "Pret pentru {unitText} într-un pachet", hc = "Cumpara", bc = "Redu cantitatea de cumparat", fc = "Creste cantitatea de cumparat", zc = "Galerie imagini produs", gc = "Arata galerie", $c = "Imaginea anterioara", jc = "Imaginea urmatoare", Pc = "Arata toate", wc = "Economiseste {amount}", xc = "Configureaza-ti Watchdog", qc = "Vezi si", Sc = "Îti vom trimite un email imediat ce acest produs va fi din nou pe stoc.", Nc = "Am configurat un watchdog.", Dc = "Pret internet", Vc = "Pret internet - descriere", Cc = "În stoc pe magazinul online", Ec = "Ridicare in farmacie GRATUIT", Mc = "Disponibil pentru ridicare GRATUIT", Uc = "Disponibil pentru ridicare in farmacie", Ac = "Alege farmacia ta", Tc = "bucata", Rc = "buc.", Zc = "Zadaný ePoukaz je již načten v košíku.", Lc = "Esec la încarcarea detaliilor produsului.", Bc = "Sunt de acord cu {link}", Oc = "contactarea condițiilor de contact", Ic = "Consimțământul pentru contact trebuie confirmat", Fc = "Livrare către tine deja", Jc = "Pentru ridicare deja", Kc = "Disponibil pentru ridicare de la farmacie deja", Qc = "Toate opțiunile de livrare", Hc = "Ridicare personală", Wc = "Livrare către tine", Yc = "Imediat", Gc = "Astăzi", Xc = "Mâine", el = "de la", ol = {
  general_reviews: $r,
  issue_medical_voucher: jr,
  voucher_details_explanation: Pr,
  enter_voucher_code: wr,
  voucher_code_entry_instruction: xr,
  voucher_code_entry_instruction_verification: qr,
  select_quantity_and_add_products: Sr,
  product_quantity_selection_instruction: Nr,
  arrange_home_delivery: Dr,
  home_delivery_selection_instruction: Vr,
  comfort_from_home: Cr,
  order_your_voucher: Er,
  direct_delivery: Mr,
  secure_delivery_explanation: Ur,
  free_shipping: Ar,
  free_shipping_explanation: Tr,
  complete_professional_support: Rr,
  pharmacist_support_details: Zr,
  all_at_once: Lr,
  all_at_once_explanation: Br,
  safety_and_discretion: Or,
  safety_and_discretion_explanation: Ir,
  eprescription_how_it_works: Fr,
  eprescription_how_it_works_colored: Jr,
  why_use_eprescription: Kr,
  what_is_eprescription_colored: Qr,
  what_is_eprescription: Hr,
  eprescription_info: Wr,
  eprescription_info_electronic: Yr,
  eprescription_disabled_title: Gr,
  eprescription_disabled_info: Xr,
  have_you_heard_about_electronic_prescription: ei,
  does_voucher_include_code_and_qr: oi,
  voucher_can_be_redeemed_electronically: ti,
  yes: ni,
  no_does_not_include_information: ai,
  voucher_cannot_be_redeemed_electronically: ri,
  find_benu_pharmacy: ii,
  shop_medical_equipments: si,
  electronic_form: ci,
  printed_form: li,
  eprescription_have_form: di,
  received_eprescription: ui,
  without_eprescription: _i,
  buy_medical_equipments: pi,
  medical_equipments: mi,
  medical_equipments_how_to_order: ki,
  medical_equipments_info: vi,
  eprescription_info_subtitle: yi,
  eprescription_info_title: hi,
  eprescription_info_description: bi,
  eprescription_input_code: fi,
  faq_title: zi,
  eprescription_nominativ: gi,
  eprescription_genitiv: $i,
  app_banner_title: ji,
  app_banner_description: Pi,
  crossroad_title: wi,
  crossroad_reservation: xi,
  crossroad_availability: qi,
  crossroad_online_support: Si,
  crossroad_health_articles: Ni,
  support_title: Di,
  support_email: Vi,
  support_phone_number: Ci,
  support_info: Ei,
  apply_eprescription: Mi,
  enter_eprescription_code: Ui,
  eprescription_code_location: Ai,
  confirm: Ti,
  e_prescription_label: Ri,
  expire_at: Zi,
  expired_already: Li,
  eprescription_searching: Bi,
  delivery_to_bed: Oi,
  prescribed_quantity: Ii,
  pieces: Fi,
  sukl_code: Ji,
  eshop_back: Ki,
  eprescription_enter_new_code: Qi,
  alert_expired_title: Hi,
  alert_expired_message: Wi,
  alert_fully_used_title: Yi,
  alert_fully_used_message: Gi,
  alert_out_of_stock_title: Xi,
  alert_out_of_stock_message: es,
  alert_soon_to_be_expired_title: os,
  alert_soon_to_be_expired_message: ts,
  alert_forbidden_product_title: ns,
  alert_forbidden_product_message: as,
  alert_personal_check_required_title: rs,
  alert_personal_check_required_message: is,
  alert_unknown_product_title: ss,
  alert_unknown_product_message: cs,
  alert_blocked_title: ls,
  alert_blocked_message: ds,
  let_me_know: us,
  email_placeholder: _s,
  email_required: ps,
  email_invalid: ms,
  watch_dog_success: ks,
  watch_dog_error: vs,
  "buy_product_on_e-shop": "Zobrazit produkt na e-shopu",
  search_for_closest_pharmacy: ys,
  list_of_specialized_stores: hs,
  eprescription_summary: bs,
  general_price: fs,
  insurance_coverage: zs,
  your_contribution: gs,
  amount_due: $s,
  add_to_basket: js,
  require_in_person_consultation: Ps,
  cannot_be_issued_online: ws,
  product_in_stock: xs,
  product_out_of_stock: qs,
  eprescription_insert_next: Ss,
  prebasket_item_insert_notification: Ns,
  prebasket_delivery: Ds,
  general_free: Vs,
  continue_to_basket: Cs,
  thank_you_message: Es,
  reservation_sent: Ms,
  reservation_confirmation: Us,
  print_order_summary: As,
  you_may_be_interested: Ts,
  add_to_cart: Rs,
  pickup_meds_from_erecept: Zs,
  quantity: Ls,
  show_less: Bs,
  show_more: Os,
  eprescription_more_about: Is,
  eprescription_code_not_found: Fs,
  rx_reservation_code_submitted: Js,
  redeem_voucher: Ks,
  enter_code_manually: Qs,
  scan_qr_code: Hs,
  select_qr_code_from_gallery: Ws,
  eprescription_quantity_warning: Ys,
  error_something_went_wrong: Gs,
  try_again: Xs,
  load_again: ec,
  unsaved_changes: oc,
  eprescription_leave_question: tc,
  general_back: nc,
  general_continue: ac,
  add_to_cart_error: rc,
  general_leave: ic,
  general_unavailable: sc,
  general_unavailable_product: cc,
  not_for_sale_separately: lc,
  general_out_of: dc,
  go_to_image: uc,
  general_tags: _c,
  toggle_favourite: pc,
  general_more: mc,
  product_variants_title: kc,
  product_bundles_title: vc,
  unit_price_label: yc,
  general_buy: hc,
  general_decrease_quantity: bc,
  general_increase_quantity: fc,
  product_detail_gallery: zc,
  show_gallery: gc,
  previous_image: $c,
  next_image: jc,
  show_all_images: Pc,
  save_amount_notification: wc,
  watch_dog_setup_prompt: xc,
  take_a_look_also_at_following_categories: qc,
  watch_dog_stock_email_info: Sc,
  watch_dog_setup_confirmation: Nc,
  internet_price: Dc,
  internet_price_tooltip: Vc,
  in_stock_on_e_shop: Cc,
  free_pickup_on_pharmacy: Ec,
  immediate_pickup: Mc,
  otc_tag: Uc,
  choose_pharmacy: Ac,
  general_piece: Tc,
  general_piece_abbr: Rc,
  eprescription_already_loaded: Zc,
  failed_to_load_product_detail_data: Lc,
  general_i_agree_with: Bc,
  watchdog_consent_terms_conditions: Oc,
  watchdog_consent_required: Ic,
  carrier_delivery_to_you: Fc,
  pickup_delivery_to_you: Jc,
  pickup_delivery_to_you_pharmacy: Kc,
  all_delivery_options: Qc,
  personal_pickup: Hc,
  carrier_delivery: Wc,
  date_immediately: Yc,
  date_today: Gc,
  date_tomorrow: Xc,
  from: el
}, tl = "Recenzie", nl = "Nechte si u lékaře vystavit ePoukaz", al = "Váš lékař vám vystaví ePoukaz na léčebnou nebo ortopedickou pomůcku a sdělí vám její 9místný identifikátor formou SMS zprávy, e-mailem nebo tištěného poukazu.", rl = "Vložte kód ePoukazu", il = "Do webového formuláře nebo v BENU aplikaci v záložce ePoukaz, zadejte 9místný kód z ePoukazu vypsáním, naskenováním QR kódu přes kameru nebo jej vyberte z galerie", sl = "My ověříme jeho platnost a zobrazíme zdravotnické pomůcky předepsané lékařem.", cl = "Vyberte množství a přidejte produkty z ePoukazu do košíku", ll = "Na detailu produktu upravte požadované množství zdravotnické pomůcky, vložte do košíku a podle přání přidejte i ostatní zboží.", dl = "Nechte si zdravotnické pomůcky doručit až domů", ul = "V košíku vyberte místo doručení, typ dopravy a plaťte vámi preferovaným způsobem. My vám zboží doručíme jako běžnou zásilku z e-shopu na vámi vybrané místo, v bezpečném a diskrétním balení. Vy se můžete těšit na svou objednávku a také sledovat její stav v aplikaci či na webu benu.cz", _l = "Pohodlně z domova", pl = "Objednejte si svůj ePoukaz, když ho potřebujete, a to stejným způsobem jako zboží z e-shopu.", ml = "Doručení přímo k vám", kl = "Zajistíme bezpečné doručení zdravotnických prostředků z ePoukazu přímo k vašim dveřím nebo do vaší oblíbené lékárny.", vl = "Doprava ZDARMA", yl = "Uplatněte si ePoukaz na BENU.cz a náklady za dopravu uhradíme za vás.", hl = "Kompletní odborná podpora", bl = "Naši farmaceuti vám pomohou s výběrem a rovněž vám rádi zodpoví dotazy na sortiment a použití zdravotnických prostředků.", fl = "Vše najednou", zl = "Spolu s ePoukazem můžete jednoduše přidat do nákupního košíku i další vybrané produkty z e-shopu a nechat si doručit vše dohromady.", gl = "Bezpečnost a diskrétnost", $l = "Při nákupech u nás si můžete být jisti, že vám poskytneme bezpečné a diskrétní prostředí pro zajištění maximální spokojenosti.", jl = "Jak ePoukaz funguje?", Pl = "Jak {eVoucherInflection} funguje?", wl = "Proč uplatnit {eVoucherInflection} online?", xl = "Co je {eVoucherInflection}?", ql = "Co je to ePoukaz?", Sl = "ePoukaz nebo Poukaz je forma lékařského předpisu na léčebnou nebo ortopedickou pomůcku předepisovanou lékařem. Lze na něj předepsat různé typy zdravotnických prostředků, jako například inkontinenční či stomické pomůcky, pomůcky na monitoring glukózy nebo obvazový materiál.", Nl = "Poukaz vystavený elektronicky je ePoukaz. Jeho součástí je 9místný alfanumerický identifikátor, který můžete obdržet formou SMS, e-mailem nebo i jako tištěnou průvodku. Jeho platnost je 30 dní a může se na něj vztahovat plná nebo částečná úhrada zdravotní pojišťovny.", Dl = "Jaké Poukazy nelze vydat ONLINE na BENU.cz?", Vl = "Online nelze objednat zdravotnické prostředky na papírový poukaz nebo pomůcky aplikované pod dozorem zdravotníka (sluchadla, injekčně aplikované přípravky, dioptrické brýle apod.) či přístroje nadměrných velikostí (invalidní vozíky apod.)", Cl = "Slyšeli jste už o elektronické formě lékařského předpisu na léčebnou a ortopedickou pomůcku?", El = "Obsahuje váš tištěný poukaz 9místný kód a QR kód?", Ml = "Váš poukaz lze uplatnit elektronicky.", Ul = "Ano", Al = "Ne, neobsahuje tyto údaje.", Tl = "Váš poukaz bohužel nelze uplatnit elektronicky. Uplatněte jej v lékárně, nebo nakupte zdravotnické pomůcky bez poukazu na e-shopu.", Rl = "Najít BENU lékárnu", Zl = "Nakupovat zdravotnické pomůcky", Ll = "elektronický", Bl = "tištěný", Ol = "Mám {form} poukaz", Il = "Lékař mi poslal SMS či e-mail s předpisem na zdravotnickou pomůcku.", Fl = "Nemám poukaz, ale chci nakoupit {medicalEquipments}", Jl = "Nakupujte oblíbené produkty za standardní ceny bez poukazu na našem e-shopu.", Kl = "zdravotnické pomůcky", Ql = "Jak objednat {medicalEquipments}?", Hl = "Máte od lékaře Poukaz na léčebnou nebo ortopedickou pomůcku? Své předepsané pomůcky si na BENU.cz můžete objednat ZDARMA až domů!", Wl = "Elektronický poukaz na léčebnou a ortopedickou pomůcku", Yl = "Zdravotnické pomůcky na {eVoucherInflection} doručíme až domů", Gl = "Objednání předepsaných zdravotnických prostředků lékařem nyní vyřešíte z pohodlí domova! Jednoduše si uplatněte svůj ePoukaz online, do košíku přihoďte i další zboží z e-shopu a my vám vše dovezeme na vámi vybranou adresu.", Xl = "Vložit kód ePoukazu", ed = "Nejčastější dotazy k {eVoucherInflection}", od = "ePoukaz", td = "ePoukazu", nd = "Máte už mobilní aplikaci?", ad = "S naší mobilní aplikací snadno zjistíte stav vaší objednávky, zarezervujete vyzvednutí eReceptu a budete mít náš e-shop vždy po ruce.", rd = "Objevte další služby, které poskytuje vaše BENU Lékárna", id = "Rezervovat eRecept", sd = "Zjistit dostupnost léků", cd = "Online poradna", ld = "Články o zdraví", dd = "Potřebujete poradit?", ud = "info{'@'}benu.cz", _d = "212 812 812", pd = 'Volejte Po-Pá od 8.00 do 17.00 nebo pište na <a href="mailto:{support_email}">{support_email}</a>.', md = "Uplatnit ePoukaz", kd = "Zadejte 9místný kód ePoukazu", vd = "Kód ePoukazu najdete na tištěné průvodce od lékaře, v SMS nebo v e-mailové zprávě.", yd = "Potvrdit", hd = "ePoukaz {ePrescriptionCode}", bd = "Platnost do {expirationDate}", fd = "Platnost expirovala {expirationDate}", zd = "Hledáme pro vás ePoukaz", gd = "Nechte si produkty doručit pohodlně až domů!", $d = 'Lékařem předepsáno <span style="font-weight: 700">{quantity}</span> kusů | Lékařem předepsán <span style="font-weight: 700">{quantity}</span> kus | Lékařem předepsány <span style="font-weight: 700">{quantity}</span> kusy', jd = "{quantity} kusů | {quantity} kus | {quantity} kusy", Pd = "SUKL kód", wd = "Zpět na e-shop", xd = "Zadat nový ePoukaz", qd = "Váš ePoukaz je po době platnosti!", Sd = "Váš ePoukaz expiroval {expirationDate}. Pokud produkt stále potřebujete, požádejte svého lékaře o vystavení nového kódu ePoukazu nebo si své pomůcky můžete volně nakoupit na BENU e-shopu za standardní ceny.", Nd = "Tento ePoukaz je již plně vyčerpaný!", Dd = "Tento ePoukaz byl už plně uplatněn. Pokud tyto zdravotnické pomůcky stále potřebujete, požádejte svého lékaře o nový ePoukaz nebo si je můžete volně nakoupit na BENU e-shope za standardní ceny.", Vd = "Produkt není skladem. Nastavte si Hlídacího psa!", Cd = "Hlídací pes je služba, která vám umožní sledovat skladovou dostupnost u vámi vybraného, nedostupného zboží. Stačí zadat vaši e-mailovou adresu a při opětovném naskladnění zboží vám pošleme upozornění e-mailovou zprávou.", Ed = "Váš ePoukaz brzy expiruje!", Md = "Platnost vašeho ePoukazu je kratší něž 1 PRACOVNÍ DEN. Vzhledem k omezené otevírací době lékárny a potřebě přítomnosti farmaceuta, nejsme schopni připravit a odeslat vaše zdravotnické pomůcky včas. Pro jejich uplatnění navštivte prosím kamennou lékárnu nebo specializovanou prodejnu. Děkujeme za pochopení.", Ud = "Tuto pomůcku nelze vydat online!", Ad = "Zdravotnický prostředek tohoto typu vyžaduje dozor zdravotnického pracovníka, individuální přístup nebo ho z dalších legislativních důvodů nelze vydat online. Obraťte se prosím na specializovanou prodejnu zdravotnických potřeb.", Td = "Tuto zdravotnickou pomůcku zatím neumíme vydat online!", Rd = "Jedná se o produkt, který vyžaduje osobní konzultaci nebo individuální přístup. Pro její uplatnění navštivte prosím kamennou BENU Lékárnu. Děkujeme za pochopení.", Zd = "Váš ePoukaz byl již vydán nebo čeká na doplnění informací od lékaře.", Ld = "V tuto chvíli nemůžeme ePoukaz zpracovat. Pokud potřebujete zdravotnické pomůcky, obraťte se na svého lékaře.", Bd = "Váš ePoukaz je označen jako připravovaný v BENU Lékárně K Pérovně 945/7 a aktuálně se zpracovává.", Od = "Pro více informací se obraťte na naši zákaznickou linku 212 812 812.", Id = "Dajte mi vedieť", Fd = "Vaša e-mailová adresa", Jd = "E-mailová adresa je povinná", Kd = "Zadajte platnú e-mailovú adresu", Qd = "Strážný pes bol úspešne zriadený", Hd = "Nastala chyba pri nastavovaní Strážneho psa", Wd = "Najít nejbližší BENU Lékárnu", Yd = "Seznam specializovaných prodejen", Gd = "Shrnutí ePoukazu", Xd = "Cena", eu = "Úhrada pojišťovny", ou = "Váš doplatek", tu = "{amount} Kč", nu = "Vložit do košíku", au = "Pomůcka vyžadující osobní konzultaci", ru = "Pomůcku nelze vydat online", iu = "Skladem na e-shopu", su = "Nedostupný", cu = "Vložit další ePoukaz", lu = "Vložili jste produkt z ePoukazu do košíku!", du = "Díky ePoukazu máte dopravu {price}", uu = "zdarma", _u = "Pokračovat do košíku", pu = "Děkujeme a těšíme se na Vás!", mu = "Vaše rezervace č. {orderNumber} byla odeslána", ku = "Potvrzení rezervace jsme odeslali na e-mail a.ahmad{'@'}benu.cz. Jakmile bude váš balíček přípraven k vyzvednutí na pobočce K Pérovně, Praha 9 (dnes otevřeno 9-19 hod), pošleme vám SMS a e-mail. Hned potom můžete vyrazit pro svou objednávku.", vu = "Vytisknout shrnutí objednávky", yu = "Mohlo by vás zajímat", hu = "Přidat do košíku", bu = "Potřebujete si vyzvednout léky z eReceptu?", fu = "Množství", zu = "Menej", gu = "Viac", $u = "Více o ePoukazu", ju = "Bohužel, zadaný kód ePoukazu jsme nenalezli.", Pu = 'Zadali jste kód eReceptu, pro jeho uplatnění pokračujte na stránku <a href="{link}">www.benunapredpis.cz</a>', wu = "Uplatněte ePoukaz", xu = "Zadat kód ručně", qu = "Naskenovat QR kód", Su = "Vybrat QR kód z galerie", Nu = "Při objednání menšího množství, než vám předepsal lékař, zůstane váš ePoukaz platný do vyčerpání všech předepsaných kusů nebo do konce jeho platnosti.", Du = "Něco se pokazilo.", Vu = "Zkuste to znovu prosím!", Cu = "Načíst znovu", Eu = "Máte neuložené změny.", Mu = "Opravdu chcete ePoukaz opustit?", Uu = "Zpět", Au = "Pokračovat", Tu = "Při přidávání produktu do košíku došlo k chybě. Zkuste to prosím znovu.", Ru = "Opustit", Zu = "Momentálne nedostupné", Lu = "Nedostupný produkt", Bu = "Samostatne nepredajné", Ou = "z", Iu = "Zobraziť obrázok {imageNumber}", Fu = "Štítky", Ju = "Přidat do oblíbených", Ku = "Viac", Qu = "Ďalšie varianty", Hu = "Kúpte viac a získajte lepšiu cenu", Wu = "Cena za {unitText} v balení", Yu = "Znížiť množstvo ku kúpe", Gu = "Zvýšiť množstvo ku kúpe", Xu = "Kúpiť", e_ = "Galéria obrázkov produktu", o_ = "Zobraziť galériu", t_ = "Predošlý obrázok", n_ = "Ďalší obrázok", a_ = "Zobraziť všetko", r_ = "Ušetrite {amount}", i_ = "Nastavte si Strážneho psa", s_ = "Skúste pozrieť aj", c_ = "Zašleme vám e-mail, len čo bude táto položka opäť dostupná.", l_ = "Nastavili sme vám Strážneho psa.", d_ = "Internetová cena", u_ = "Internetová cena - čo to znamená?", __ = "Skladom v e-shope", p_ = "Osobný odber v lekárni ZADARMO", m_ = "K vyzdvihnutiu ihneď ZADARMO", k_ = "K vyzdvihnutiu ihneď", v_ = "Vyberte lekáreň", y_ = "kus", h_ = "ks", b_ = "Zadaný ePoukaz je již načten v košíku.", f_ = "Nepodarilo sa načítať podrobnosti produktu.", z_ = "Súhlasím s {link}", g_ = "podmienkami kontaktovania", $_ = "Súhlas s kontaktom sa musí potvrdiť", j_ = "Doručenie k vám už", P_ = "K vyzdvihnutiu už", w_ = "K vyzdvihnutiu na lékárni už", x_ = "Všetky možnosti doručenia", q_ = "Osobný odber", S_ = "Doručenie k vám", N_ = "Hneď", D_ = "Dnes", V_ = "Zajtra", C_ = "od", E_ = {
  general_reviews: tl,
  issue_medical_voucher: nl,
  voucher_details_explanation: al,
  enter_voucher_code: rl,
  voucher_code_entry_instruction: il,
  voucher_code_entry_instruction_verification: sl,
  select_quantity_and_add_products: cl,
  product_quantity_selection_instruction: ll,
  arrange_home_delivery: dl,
  home_delivery_selection_instruction: ul,
  comfort_from_home: _l,
  order_your_voucher: pl,
  direct_delivery: ml,
  secure_delivery_explanation: kl,
  free_shipping: vl,
  free_shipping_explanation: yl,
  complete_professional_support: hl,
  pharmacist_support_details: bl,
  all_at_once: fl,
  all_at_once_explanation: zl,
  safety_and_discretion: gl,
  safety_and_discretion_explanation: $l,
  eprescription_how_it_works: jl,
  eprescription_how_it_works_colored: Pl,
  why_use_eprescription: wl,
  what_is_eprescription_colored: xl,
  what_is_eprescription: ql,
  eprescription_info: Sl,
  eprescription_info_electronic: Nl,
  eprescription_disabled_title: Dl,
  eprescription_disabled_info: Vl,
  have_you_heard_about_electronic_prescription: Cl,
  does_voucher_include_code_and_qr: El,
  voucher_can_be_redeemed_electronically: Ml,
  yes: Ul,
  no_does_not_include_information: Al,
  voucher_cannot_be_redeemed_electronically: Tl,
  find_benu_pharmacy: Rl,
  shop_medical_equipments: Zl,
  electronic_form: Ll,
  printed_form: Bl,
  eprescription_have_form: Ol,
  received_eprescription: Il,
  without_eprescription: Fl,
  buy_medical_equipments: Jl,
  medical_equipments: Kl,
  medical_equipments_how_to_order: Ql,
  medical_equipments_info: Hl,
  eprescription_info_subtitle: Wl,
  eprescription_info_title: Yl,
  eprescription_info_description: Gl,
  eprescription_input_code: Xl,
  faq_title: ed,
  eprescription_nominativ: od,
  eprescription_genitiv: td,
  app_banner_title: nd,
  app_banner_description: ad,
  crossroad_title: rd,
  crossroad_reservation: id,
  crossroad_availability: sd,
  crossroad_online_support: cd,
  crossroad_health_articles: ld,
  support_title: dd,
  support_email: ud,
  support_phone_number: _d,
  support_info: pd,
  apply_eprescription: md,
  enter_eprescription_code: kd,
  eprescription_code_location: vd,
  confirm: yd,
  e_prescription_label: hd,
  expire_at: bd,
  expired_already: fd,
  eprescription_searching: zd,
  delivery_to_bed: gd,
  prescribed_quantity: $d,
  pieces: jd,
  sukl_code: Pd,
  eshop_back: wd,
  eprescription_enter_new_code: xd,
  alert_expired_title: qd,
  alert_expired_message: Sd,
  alert_fully_used_title: Nd,
  alert_fully_used_message: Dd,
  alert_out_of_stock_title: Vd,
  alert_out_of_stock_message: Cd,
  alert_soon_to_be_expired_title: Ed,
  alert_soon_to_be_expired_message: Md,
  alert_forbidden_product_title: Ud,
  alert_forbidden_product_message: Ad,
  alert_personal_check_required_title: Td,
  alert_personal_check_required_message: Rd,
  alert_unknown_product_title: Zd,
  alert_unknown_product_message: Ld,
  alert_blocked_title: Bd,
  alert_blocked_message: Od,
  let_me_know: Id,
  email_placeholder: Fd,
  email_required: Jd,
  email_invalid: Kd,
  watch_dog_success: Qd,
  watch_dog_error: Hd,
  "buy_product_on_e-shop": "Zobrazit produkt na e-shopu",
  search_for_closest_pharmacy: Wd,
  list_of_specialized_stores: Yd,
  eprescription_summary: Gd,
  general_price: Xd,
  insurance_coverage: eu,
  your_contribution: ou,
  amount_due: tu,
  add_to_basket: nu,
  require_in_person_consultation: au,
  cannot_be_issued_online: ru,
  product_in_stock: iu,
  product_out_of_stock: su,
  eprescription_insert_next: cu,
  prebasket_item_insert_notification: lu,
  prebasket_delivery: du,
  general_free: uu,
  continue_to_basket: _u,
  thank_you_message: pu,
  reservation_sent: mu,
  reservation_confirmation: ku,
  print_order_summary: vu,
  you_may_be_interested: yu,
  add_to_cart: hu,
  pickup_meds_from_erecept: bu,
  quantity: fu,
  show_less: zu,
  show_more: gu,
  eprescription_more_about: $u,
  eprescription_code_not_found: ju,
  rx_reservation_code_submitted: Pu,
  redeem_voucher: wu,
  enter_code_manually: xu,
  scan_qr_code: qu,
  select_qr_code_from_gallery: Su,
  eprescription_quantity_warning: Nu,
  error_something_went_wrong: Du,
  try_again: Vu,
  load_again: Cu,
  unsaved_changes: Eu,
  eprescription_leave_question: Mu,
  general_back: Uu,
  general_continue: Au,
  add_to_cart_error: Tu,
  general_leave: Ru,
  general_unavailable: Zu,
  general_unavailable_product: Lu,
  not_for_sale_separately: Bu,
  general_out_of: Ou,
  go_to_image: Iu,
  general_tags: Fu,
  toggle_favourite: Ju,
  general_more: Ku,
  product_variants_title: Qu,
  product_bundles_title: Hu,
  unit_price_label: Wu,
  general_decrease_quantity: Yu,
  general_increase_quantity: Gu,
  general_buy: Xu,
  product_detail_gallery: e_,
  show_gallery: o_,
  previous_image: t_,
  next_image: n_,
  show_all_images: a_,
  save_amount_notification: r_,
  watch_dog_setup_prompt: i_,
  take_a_look_also_at_following_categories: s_,
  watch_dog_stock_email_info: c_,
  watch_dog_setup_confirmation: l_,
  internet_price: d_,
  internet_price_tooltip: u_,
  in_stock_on_e_shop: __,
  free_pickup_on_pharmacy: p_,
  immediate_pickup: m_,
  otc_tag: k_,
  choose_pharmacy: v_,
  general_piece: y_,
  general_piece_abbr: h_,
  eprescription_already_loaded: b_,
  failed_to_load_product_detail_data: f_,
  general_i_agree_with: z_,
  watchdog_consent_terms_conditions: g_,
  watchdog_consent_required: $_,
  carrier_delivery_to_you: j_,
  pickup_delivery_to_you: P_,
  pickup_delivery_to_you_pharmacy: w_,
  all_delivery_options: x_,
  personal_pickup: q_,
  carrier_delivery: S_,
  date_immediately: N_,
  date_today: D_,
  date_tomorrow: V_,
  from: C_
}, M_ = "Recenzije", U_ = "Nechte si u lékaře vystavit ePoukaz", A_ = "Váš lékař vám vystaví ePoukaz na léčebnou nebo ortopedickou pomůcku a sdělí vám její 9místný identifikátor formou SMS zprávy, e-mailem nebo tištěného poukazu.", T_ = "Vložte kód ePoukazu", R_ = "Do webového formuláře nebo v BENU aplikaci v záložce ePoukaz, zadejte 9místný kód z ePoukazu vypsáním, naskenováním QR kódu přes kameru nebo jej vyberte z galerie", Z_ = "My ověříme jeho platnost a zobrazíme zdravotnické pomůcky předepsané lékařem.", L_ = "Vyberte množství a přidejte produkty z ePoukazu do košíku", B_ = "Na detailu produktu upravte požadované množství zdravotnické pomůcky, vložte do košíku a podle přání přidejte i ostatní zboží.", O_ = "Nechte si zdravotnické pomůcky doručit až domů", I_ = "V košíku vyberte místo doručení, typ dopravy a plaťte vámi preferovaným způsobem. My vám zboží doručíme jako běžnou zásilku z e-shopu na vámi vybrané místo, v bezpečném a diskrétním balení. Vy se můžete těšit na svou objednávku a také sledovat její stav v aplikaci či na webu benu.cz", F_ = "Pohodlně z domova", J_ = "Objednejte si svůj ePoukaz, když ho potřebujete, a to stejným způsobem jako zboží z e-shopu.", K_ = "Doručení přímo k vám", Q_ = "Zajistíme bezpečné doručení zdravotnických prostředků z ePoukazu přímo k vašim dveřím nebo do vaší oblíbené lékárny.", H_ = "Doprava ZDARMA", W_ = "Uplatněte si ePoukaz na BENU.cz a náklady za dopravu uhradíme za vás.", Y_ = "Kompletní odborná podpora", G_ = "Naši farmaceuti vám pomohou s výběrem a rovněž vám rádi zodpoví dotazy na sortiment a použití zdravotnických prostředků.", X_ = "Vše najednou", ep = "Spolu s ePoukazem můžete jednoduše přidat do nákupního košíku i další vybrané produkty z e-shopu a nechat si doručit vše dohromady.", op = "Bezpečnost a diskrétnost", tp = "Při nákupech u nás si můžete být jisti, že vám poskytneme bezpečné a diskrétní prostředí pro zajištění maximální spokojenosti.", np = "Jak ePoukaz funguje?", ap = "Jak {eVoucherInflection} funguje?", rp = "Proč uplatnit {eVoucherInflection} online?", ip = "Co je {eVoucherInflection}?", sp = "Co je to ePoukaz?", cp = "ePoukaz nebo Poukaz je forma lékařského předpisu na léčebnou nebo ortopedickou pomůcku předepisovanou lékařem. Lze na něj předepsat různé typy zdravotnických prostředků, jako například inkontinenční či stomické pomůcky, pomůcky na monitoring glukózy nebo obvazový materiál.", lp = "Poukaz vystavený elektronicky je ePoukaz. Jeho součástí je 9místný alfanumerický identifikátor, který můžete obdržet formou SMS, e-mailem nebo i jako tištěnou průvodku. Jeho platnost je 30 dní a může se na něj vztahovat plná nebo částečná úhrada zdravotní pojišťovny.", dp = "Jaké Poukazy nelze vydat ONLINE na BENU.cz?", up = "Online nelze objednat zdravotnické prostředky na papírový poukaz nebo pomůcky aplikované pod dozorem zdravotníka (sluchadla, injekčně aplikované přípravky, dioptrické brýle apod.) či přístroje nadměrných velikostí (invalidní vozíky apod.)", _p = "Slyšeli jste už o elektronické formě lékařského předpisu na léčebnou a ortopedickou pomůcku?", pp = "Obsahuje váš tištěný poukaz 9místný kód a QR kód?", mp = "Váš poukaz lze uplatnit elektronicky.", kp = "Ano", vp = "Ne, neobsahuje tyto údaje.", yp = "Váš poukaz bohužel nelze uplatnit elektronicky. Uplatněte jej v lékárně, nebo nakupte zdravotnické pomůcky bez poukazu na e-shopu.", hp = "Najít BENU lékárnu", bp = "Nakupovat zdravotnické pomůcky", fp = "elektronický", zp = "tištěný", gp = "Mám {form} poukaz", $p = "Lékař mi poslal SMS či e-mail s předpisem na zdravotnickou pomůcku.", jp = "Nemám poukaz, ale chci nakoupit {medicalEquipments}", Pp = "Nakupujte oblíbené produkty za standardní ceny bez poukazu na našem e-shopu.", wp = "zdravotnické pomůcky", xp = "Jak objednat {medicalEquipments}?", qp = "Máte od lékaře Poukaz na léčebnou nebo ortopedickou pomůcku? Své předepsané pomůcky si na BENU.cz můžete objednat ZDARMA až domů!", Sp = "Elektronický poukaz na léčebnou a ortopedickou pomůcku", Np = "Zdravotnické pomůcky na {eVoucherInflection} doručíme až domů", Dp = "Objednání předepsaných zdravotnických prostředků lékařem nyní vyřešíte z pohodlí domova! Jednoduše si uplatněte svůj ePoukaz online, do košíku přihoďte i další zboží z e-shopu a my vám vše dovezeme na vámi vybranou adresu.", Vp = "Vložit kód ePoukazu", Cp = "Nejčastější dotazy k {eVoucherInflection}", Ep = "ePoukaz", Mp = "ePoukazu", Up = "Máte už mobilní aplikaci?", Ap = "S naší mobilní aplikací snadno zjistíte stav vaší objednávky, zarezervujete vyzvednutí eReceptu a budete mít náš e-shop vždy po ruce.", Tp = "Objevte další služby, které poskytuje vaše BENU Lékárna", Rp = "Rezervovat eRecept", Zp = "Zjistit dostupnost léků", Lp = "Online poradna", Bp = "Články o zdraví", Op = "Potřebujete poradit?", Ip = "info{'@'}benu.cz", Fp = "212 812 812", Jp = 'Volejte Po-Pá od 8.00 do 17.00 nebo pište na <a href="mailto:{support_email}">{support_email}</a>.', Kp = "Uplatnit ePoukaz", Qp = "Zadejte 9místný kód ePoukazu", Hp = "Kód ePoukazu najdete na tištěné průvodce od lékaře, v SMS nebo v e-mailové zprávě.", Wp = "Potvrdit", Yp = "ePoukaz {ePrescriptionCode}", Gp = "Platnost do {expirationDate}", Xp = "Platnost expirovala {expirationDate}", em = "Hledáme pro vás ePoukaz", om = "Nechte si produkty doručit pohodlně až domů!", tm = 'Lékařem předepsáno <span style="font-weight: 700">{quantity}</span> kusů | Lékařem předepsán <span style="font-weight: 700">{quantity}</span> kus | Lékařem předepsány <span style="font-weight: 700">{quantity}</span> kusy', nm = "{quantity} kusů | {quantity} kus | {quantity} kusy", am = "SUKL kód", rm = "Zpět na e-shop", im = "Zadat nový ePoukaz", sm = "Váš ePoukaz je po době platnosti!", cm = "Váš ePoukaz expiroval {expirationDate}. Pokud produkt stále potřebujete, požádejte svého lékaře o vystavení nového kódu ePoukazu nebo si své pomůcky můžete volně nakoupit na BENU e-shopu za standardní ceny.", lm = "Tento ePoukaz je již plně vyčerpaný!", dm = "Tento ePoukaz byl už plně uplatněn. Pokud tyto zdravotnické pomůcky stále potřebujete, požádejte svého lékaře o nový ePoukaz nebo si je můžete volně nakoupit na BENU e-shope za standardní ceny.", um = "Produkt není skladem. Nastavte si Hlídacího psa!", _m = "Hlídací pes je služba, která vám umožní sledovat skladovou dostupnost u vámi vybraného, nedostupného zboží. Stačí zadat vaši e-mailovou adresu a při opětovném naskladnění zboží vám pošleme upozornění e-mailovou zprávou.", pm = "Váš ePoukaz brzy expiruje!", mm = "Platnost vašeho ePoukazu je kratší něž 1 PRACOVNÍ DEN. Vzhledem k omezené otevírací době lékárny a potřebě přítomnosti farmaceuta, nejsme schopni připravit a odeslat vaše zdravotnické pomůcky včas. Pro jejich uplatnění navštivte prosím kamennou lékárnu nebo specializovanou prodejnu. Děkujeme za pochopení.", km = "Tuto pomůcku nelze vydat online!", vm = "Zdravotnický prostředek tohoto typu vyžaduje dozor zdravotnického pracovníka, individuální přístup nebo ho z dalších legislativních důvodů nelze vydat online. Obraťte se prosím na specializovanou prodejnu zdravotnických potřeb.", ym = "Tuto zdravotnickou pomůcku zatím neumíme vydat online!", hm = "Jedná se o produkt, který vyžaduje osobní konzultaci nebo individuální přístup. Pro její uplatnění navštivte prosím kamennou BENU Lékárnu. Děkujeme za pochopení.", bm = "Váš ePoukaz byl již vydán nebo čeká na doplnění informací od lékaře.", fm = "V tuto chvíli nemůžeme ePoukaz zpracovat. Pokud potřebujete zdravotnické pomůcky, obraťte se na svého lékaře.", zm = "Váš ePoukaz je označen jako připravovaný v BENU Lékárně K Pérovně 945/7 a aktuálně se zpracovává.", gm = "Pro více informací se obraťte na naši zákaznickou linku 212 812 812.", $m = "Javite mi", jm = "Vaša adresa e-pošte", Pm = "E-mail adresa je obavezna", wm = "Unesite važeću adresu e-pošte", xm = "Watchdog je uspešno podešen.", qm = "Došlo je do greške prilikom postavljanja Watchdog-a", Sm = "Najít nejbližší BENU Lékárnu", Nm = "Seznam specializovaných prodejen", Dm = "Shrnutí ePoukazu", Vm = "Cena", Cm = "Úhrada pojišťovny", Em = "Váš doplatek", Mm = "{amount} Kč", Um = "Vložit do košíku", Am = "Pomůcka vyžadující osobní konzultaci", Tm = "Pomůcku nelze vydat online", Rm = "Skladem na e-shopu", Zm = "Nedostupný", Lm = "Vložit další ePoukaz", Bm = "Vložili jste produkt z ePoukazu do košíku!", Om = "Díky ePoukazu máte dopravu {price}", Im = "zdarma", Fm = "Pokračovat do košíku", Jm = "Děkujeme a těšíme se na Vás!", Km = "Vaše rezervace č. {orderNumber} byla odeslána", Qm = "Potvrzení rezervace jsme odeslali na e-mail a.ahmad{'@'}benu.cz. Jakmile bude váš balíček přípraven k vyzvednutí na pobočce K Pérovně, Praha 9 (dnes otevřeno 9-19 hod), pošleme vám SMS a e-mail. Hned potom můžete vyrazit pro svou objednávku.", Hm = "Vytisknout shrnutí objednávky", Wm = "Mohlo by vás zajímat", Ym = "Přidat do košíku", Gm = "Potřebujete si vyzvednout léky z eReceptu?", Xm = "Množství", ek = "Pprikaži manje", ok = "Prikaži više", tk = "Více o ePoukazu", nk = "Bohužel, zadaný kód ePoukazu jsme nenalezli.", ak = 'Zadali jste kód eReceptu, pro jeho uplatnění pokračujte na stránku <a href="{link}">www.benunapredpis.cz</a>', rk = "Uplatněte ePoukaz", ik = "Zadat kód ručně", sk = "Naskenovat QR kód", ck = "Vybrat QR kód z galerie", lk = "Při objednání menšího množství, než vám předepsal lékař, zůstane váš ePoukaz platný do vyčerpání všech předepsaných kusů nebo do konce jeho platnosti.", dk = "Něco se pokazilo.", uk = "Zkuste to znovu prosím!", _k = "Načíst znovu", pk = "Máte neuložené změny.", mk = "Opravdu chcete ePoukaz opustit?", kk = "Zpět", vk = "Pokračovat", yk = "Při přidávání produktu do košíku došlo k chybě. Zkuste to prosím znovu.", hk = "Opustit", bk = "Trenutno nedostupno", fk = "Nedostupan proizvod", zk = "Ne prodaje se odvojeno", gk = "Iz", $k = "Pogledaj sliku {imageNumber}", jk = "Oznake", Pk = "Přidat do oblíbených", wk = "Više", xk = "Ostale varijante", qk = "Kupite više i dobijte bolju cenu", Sk = "Cena za {unitText} u paketu", Nk = "Smanjite količinu za kupovinu", Dk = "Povećajte količinu za kupovinu", Vk = "Kupi", Ck = "Slika proizvoda galerija", Ek = "Prikaži galeriju", Mk = "Prethodna slika", Uk = "Sledeća slika", Ak = "Prikaži sve", Tk = "Sačuvaj {amount}", Rk = "Podesite svoj Watchdog", Zk = "Vidi takođe", Lk = "Poslaćemo vam e-mail čim ovaj proizvod ponovo bude dostupan.", Bk = "Postavili smo psa čuvara.", Ok = "Online cena", Ik = "Online cena - šta se pod tim podrazumeva?", Fk = "Na lageru u e-prodavnici", Jk = "Preuzimanje u apoteci BESPLATNO", Kk = "Dostupno za preuzimanje BESPLATNO", Qk = "Dostupno za preuzimanje", Hk = "Izaberite svoju apoteku", Wk = "komad", Yk = "kom", Gk = "Zadaný ePoukaz je již načten v košíku.", Xk = "Učitavanje detalja o proizvodu nije uspelo.", ev = "Slažem se sa {link}", ov = "uslovi za kontakt", tv = "Saglasnost za kontakt mora biti potvrđena", nv = "Dostava do vas već", av = "Za preuzimanje već", rv = "Već spremno za preuzimanje u apoteci", iv = "Sve opcije dostave", sv = "Osobno preuzimanje", cv = "Dostava do vas", lv = "Odmah", dv = "Danas", uv = "Sutra", _v = "od", pv = {
  general_reviews: M_,
  issue_medical_voucher: U_,
  voucher_details_explanation: A_,
  enter_voucher_code: T_,
  voucher_code_entry_instruction: R_,
  voucher_code_entry_instruction_verification: Z_,
  select_quantity_and_add_products: L_,
  product_quantity_selection_instruction: B_,
  arrange_home_delivery: O_,
  home_delivery_selection_instruction: I_,
  comfort_from_home: F_,
  order_your_voucher: J_,
  direct_delivery: K_,
  secure_delivery_explanation: Q_,
  free_shipping: H_,
  free_shipping_explanation: W_,
  complete_professional_support: Y_,
  pharmacist_support_details: G_,
  all_at_once: X_,
  all_at_once_explanation: ep,
  safety_and_discretion: op,
  safety_and_discretion_explanation: tp,
  eprescription_how_it_works: np,
  eprescription_how_it_works_colored: ap,
  why_use_eprescription: rp,
  what_is_eprescription_colored: ip,
  what_is_eprescription: sp,
  eprescription_info: cp,
  eprescription_info_electronic: lp,
  eprescription_disabled_title: dp,
  eprescription_disabled_info: up,
  have_you_heard_about_electronic_prescription: _p,
  does_voucher_include_code_and_qr: pp,
  voucher_can_be_redeemed_electronically: mp,
  yes: kp,
  no_does_not_include_information: vp,
  voucher_cannot_be_redeemed_electronically: yp,
  find_benu_pharmacy: hp,
  shop_medical_equipments: bp,
  electronic_form: fp,
  printed_form: zp,
  eprescription_have_form: gp,
  received_eprescription: $p,
  without_eprescription: jp,
  buy_medical_equipments: Pp,
  medical_equipments: wp,
  medical_equipments_how_to_order: xp,
  medical_equipments_info: qp,
  eprescription_info_subtitle: Sp,
  eprescription_info_title: Np,
  eprescription_info_description: Dp,
  eprescription_input_code: Vp,
  faq_title: Cp,
  eprescription_nominativ: Ep,
  eprescription_genitiv: Mp,
  app_banner_title: Up,
  app_banner_description: Ap,
  crossroad_title: Tp,
  crossroad_reservation: Rp,
  crossroad_availability: Zp,
  crossroad_online_support: Lp,
  crossroad_health_articles: Bp,
  support_title: Op,
  support_email: Ip,
  support_phone_number: Fp,
  support_info: Jp,
  apply_eprescription: Kp,
  enter_eprescription_code: Qp,
  eprescription_code_location: Hp,
  confirm: Wp,
  e_prescription_label: Yp,
  expire_at: Gp,
  expired_already: Xp,
  eprescription_searching: em,
  delivery_to_bed: om,
  prescribed_quantity: tm,
  pieces: nm,
  sukl_code: am,
  eshop_back: rm,
  eprescription_enter_new_code: im,
  alert_expired_title: sm,
  alert_expired_message: cm,
  alert_fully_used_title: lm,
  alert_fully_used_message: dm,
  alert_out_of_stock_title: um,
  alert_out_of_stock_message: _m,
  alert_soon_to_be_expired_title: pm,
  alert_soon_to_be_expired_message: mm,
  alert_forbidden_product_title: km,
  alert_forbidden_product_message: vm,
  alert_personal_check_required_title: ym,
  alert_personal_check_required_message: hm,
  alert_unknown_product_title: bm,
  alert_unknown_product_message: fm,
  alert_blocked_title: zm,
  alert_blocked_message: gm,
  let_me_know: $m,
  email_placeholder: jm,
  email_required: Pm,
  email_invalid: wm,
  watch_dog_success: xm,
  watch_dog_error: qm,
  "buy_product_on_e-shop": "Zobrazit produkt na e-shopu",
  search_for_closest_pharmacy: Sm,
  list_of_specialized_stores: Nm,
  eprescription_summary: Dm,
  general_price: Vm,
  insurance_coverage: Cm,
  your_contribution: Em,
  amount_due: Mm,
  add_to_basket: Um,
  require_in_person_consultation: Am,
  cannot_be_issued_online: Tm,
  product_in_stock: Rm,
  product_out_of_stock: Zm,
  eprescription_insert_next: Lm,
  prebasket_item_insert_notification: Bm,
  prebasket_delivery: Om,
  general_free: Im,
  continue_to_basket: Fm,
  thank_you_message: Jm,
  reservation_sent: Km,
  reservation_confirmation: Qm,
  print_order_summary: Hm,
  you_may_be_interested: Wm,
  add_to_cart: Ym,
  pickup_meds_from_erecept: Gm,
  quantity: Xm,
  show_less: ek,
  show_more: ok,
  eprescription_more_about: tk,
  eprescription_code_not_found: nk,
  rx_reservation_code_submitted: ak,
  redeem_voucher: rk,
  enter_code_manually: ik,
  scan_qr_code: sk,
  select_qr_code_from_gallery: ck,
  eprescription_quantity_warning: lk,
  error_something_went_wrong: dk,
  try_again: uk,
  load_again: _k,
  unsaved_changes: pk,
  eprescription_leave_question: mk,
  general_back: kk,
  general_continue: vk,
  add_to_cart_error: yk,
  general_leave: hk,
  general_unavailable: bk,
  general_unavailable_product: fk,
  not_for_sale_separately: zk,
  general_out_of: gk,
  go_to_image: $k,
  general_tags: jk,
  toggle_favourite: Pk,
  general_more: wk,
  product_variants_title: xk,
  product_bundles_title: qk,
  unit_price_label: Sk,
  general_decrease_quantity: Nk,
  general_increase_quantity: Dk,
  general_buy: Vk,
  product_detail_gallery: Ck,
  show_gallery: Ek,
  previous_image: Mk,
  next_image: Uk,
  show_all_images: Ak,
  save_amount_notification: Tk,
  watch_dog_setup_prompt: Rk,
  take_a_look_also_at_following_categories: Zk,
  watch_dog_stock_email_info: Lk,
  watch_dog_setup_confirmation: Bk,
  internet_price: Ok,
  internet_price_tooltip: Ik,
  in_stock_on_e_shop: Fk,
  free_pickup_on_pharmacy: Jk,
  immediate_pickup: Kk,
  otc_tag: Qk,
  choose_pharmacy: Hk,
  general_piece: Wk,
  general_piece_abbr: Yk,
  eprescription_already_loaded: Gk,
  failed_to_load_product_detail_data: Xk,
  general_i_agree_with: ev,
  watchdog_consent_terms_conditions: ov,
  watchdog_consent_required: tv,
  carrier_delivery_to_you: nv,
  pickup_delivery_to_you: av,
  pickup_delivery_to_you_pharmacy: rv,
  all_delivery_options: iv,
  personal_pickup: sv,
  carrier_delivery: cv,
  date_immediately: lv,
  date_today: dv,
  date_tomorrow: uv,
  from: _v
}, de = "product-detail-module", $e = {
  ePrescriptionBackToEshopLink: "/",
  ePrescriptionBasketLink: "/kosik",
  ePrescriptionClosestPharmacyLink: "/nejblizsi-lekarna",
  ePrescriptionMedicalSuppliesLink: "/zdravotnicke-potreby",
  ePrescriptionSpecializedStoresLink: "/seznam-specializovaných-prodejen",
  ePrescriptionLink: "/epoukaz",
  eRecipeReserveLink: "/rezervovat-erecept",
  drugsAvailabilityLink: "/zjistit-dostupnost-leku",
  onlineConsultationLink: "/online-poradna",
  healthArticlesLink: "/clanky-o-zdravi",
  otcReservationPharmaciesLink: "/moznost-rezervace-na-lekarnach",
  termsAndConditionsLink: "/obchodni-podminky",
  addProductToBasketPath: "/api/v1/baskets/hash/products",
  updateBasketQuantityPath: "/api/v1/baskets/hash/items/id",
  removeProductFromBasketPath: "/api/v1/baskets/hash/items/id",
  ePrescriptionCodePath: "/api/v1/eprescription",
  ePrescriptionCodeValidationPath: "/api/v1/eprescription/validate",
  productWatchDogSubscriptionPath: "/api/v1/product/watch",
  productDetailPath: "/api/v1/products",
  productFavoritePath: "/api/v1/products/id/favorite",
  refreshBasketBoxPath: "/api/v1/baskets/hash/refresh",
  getDeliveryDatesPath: "/api/v1/delivery-dates?itemId=159401"
}, mv = { cs: gr, ro: ol, sk: E_, sr: pv }, S = Pe(
  "product-detail-attributes",
  $e
), kv = { class: "flex flex-col" }, vv = { class: "flex items-center justify-center gap-x-0.5 p-2.5 md:justify-start md:p-1.5 md:px-0" }, yv = ["href"], hv = /* @__PURE__ */ w({
  __name: "ProductDetailEPrescriptionOrder",
  setup(o) {
    const { md: e } = be(), t = S(), n = Oe(), { toggleDialog: a, toggleInputOptionsSheet: l } = n, s = z(() => t.datasetUrls.ePrescriptionLink);
    function u() {
      a(e.value), l(!e.value);
    }
    return (_, p) => (c(), d(g, null, [
      r("div", kv, [
        h(i(O), {
          class: "w-full px-4 py-3 md:w-fit",
          label: _.$t("apply_eprescription"),
          variant: "secondary",
          onClick: u
        }, null, 8, ["label"]),
        r("div", vv, [
          p[0] || (p[0] = r("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            class: "aspect-square size-4 text-secondary-700 md:w-4"
          }, [
            r("path", {
              fill: "currentColor",
              d: "m16.004 9.414l-8.607 8.607l-1.414-1.414L14.59 8H7.003V6h11v11h-2z"
            })
          ], -1)),
          r("a", {
            href: s.value,
            class: "text-mobile-body-s text-secondary-700 no-underline hover:underline sm:text-desktop-body-s"
          }, m(_.$t("what_is_eprescription")), 9, yv)
        ])
      ]),
      h(Ie),
      h(Fe)
    ], 64));
  }
});
async function bv(o) {
  const e = S();
  try {
    const { data: t } = await C.post(
      `${e.datasetUrls.addProductToBasketPath}`,
      o
    );
    return t;
  } catch {
    throw new Error("Error while adding product to basket");
  }
}
async function fv(o) {
  const e = S();
  try {
    const {
      status: t,
      data: { quantity: n }
    } = await C.post(
      `${e.datasetUrls.updateBasketQuantityPath}`,
      { quantity: o }
    );
    if (t === 200) return n;
  } catch (t) {
    return console.error("Error updating basket quantity: ", t), null;
  }
}
async function zv() {
  const o = S();
  try {
    const { status: e } = await C.delete(`${o.datasetUrls.removeProductFromBasketPath}`);
    if (e === 200) return !0;
  } catch (e) {
    return console.error("Error removing product from basket: ", e), null;
  }
}
function gv(o, e) {
  try {
    const t = new URL(o), n = new URLSearchParams(t.search);
    return $v(n, e), t.search = jv(n.toString()), t.toString();
  } catch {
    throw new TypeError(`Invalid URL: ${o}`);
  }
}
function $v(o, e) {
  for (const [t, n] of Object.entries(e))
    n != null && o.set(t, `${n}`);
}
function jv(o) {
  return o.replace(/\+/g, "%20");
}
const F = ue("basket", () => {
  const o = D(1), e = D(!1);
  async function t(l, s) {
    const u = S(), _ = o.value ?? 0;
    e.value = !0, o.value = s;
    try {
      const { addedItem: p } = await bv({
        productId: l,
        quantity: s,
        preferredVariant: null
      });
      Dv(), ve(
        gv(u.datasetUrls.refreshBasketBoxPath, {
          quantity: s,
          added: p.hash
        }),
        {
          openPdBox: !0
        }
      ), o.value = p.quantity;
    } catch {
      o.value = _;
    } finally {
      e.value = !1;
    }
  }
  async function n(l) {
    e.value = !0;
    const s = o.value ?? 0;
    o.value = l;
    try {
      const u = await fv(l);
      if (!u)
        throw new Error();
      o.value = u;
    } catch {
      o.value = s;
    } finally {
      e.value = !1;
    }
  }
  async function a() {
    e.value = !0;
    const l = o.value ?? 0;
    o.value = 0;
    try {
      if (!await zv())
        throw new Error();
    } catch {
      o.value = l;
    } finally {
      e.value = !1;
    }
  }
  return {
    quantity: o,
    isChangingQuantity: e,
    addToBasket: t,
    updateQuantity: n,
    removeFromBasket: a
  };
}), Pv = Je();
function ne(o) {
  const { itemId: e, name: t, brand: n, categories: a } = o;
  return {
    item_id: e,
    item_name: t,
    item_brand: n?.name,
    item_category: a[0]?.name,
    item_availability: o.availability.isAvailable ? "In stock" : "Out of stock"
  };
}
function je(o, e) {
  return {
    price: o.price.price,
    quantity: e
  };
}
function wv() {
  const { quantity: o } = F(), { productData: e } = E();
  if (!e || !o)
    throw new Error("Data for product added to favorites event were not provided.");
  return {
    currency: e.price.currencyCode,
    value: e.price.price * o,
    items: [
      {
        ...ne(e),
        index: 1,
        item_image_url: e.images.length ? Pv.createURL(
          +e.images[0].id,
          e.images[0].filename,
          e.images[0].extension,
          "_orig"
        ) : null
      }
    ]
  };
}
async function xv() {
  oe("add_to_wishlist", {
    ecommerce: wv()
  });
}
function qv() {
  const { quantity: o } = F(), { productData: e } = E();
  if (!e || !o)
    throw new Error("Data for product detail viewed event were not provided.");
  return {
    currency: e.price.currencyCode,
    value: e.price.price * o,
    items: [
      {
        ...ne(e),
        ...je(e, o),
        index: 1
      }
    ]
  };
}
async function Sv() {
  oe("view_item", {
    ecommerce: qv()
  });
}
function Nv() {
  const {
    datasetUrls: { addProductToBasketPath: o }
  } = S(), { quantity: e } = F(), { productData: t } = E(), n = o?.match(/\/baskets\/([^/]+)\/products/);
  if (!t || !e)
    throw new Error("Data for product added to cart event were not provided.");
  return {
    cart: {
      id: n?.length ? n[1] : null
    },
    ecommerce: {
      currency: t.price.currencyCode,
      value: t.price.price * e,
      items: [
        {
          ...ne(t),
          ...je(t, e),
          index: 1
        }
      ]
    }
  };
}
async function Dv() {
  oe("add_to_cart", {
    ...Nv()
  });
}
function Vv(o) {
  try {
    return {
      ..._e(o)
    };
  } catch {
    return {};
  }
}
async function Cv() {
  const o = S();
  try {
    const { data: e } = await C.get(
      `${o.datasetUrls.productDetailPath}`
    );
    return Vv(e);
  } catch (e) {
    throw new Error(`Failed to fetch product detail data: ${e}`);
  }
}
async function Ev(o, e, t) {
  const n = S();
  try {
    const { data: a, status: l } = await C.post(
      `${n.datasetUrls.productWatchDogSubscriptionPath}`,
      { items: o, email: e, consent: t }
    );
    return { data: a, status: l };
  } catch (a) {
    return console.error("Error subscribing watch dog for product:", a), null;
  }
}
async function Mv() {
  const o = S();
  try {
    const { data: e } = await C.get(
      `${o.datasetUrls.productFavoritePath}`
    );
    return _e(e);
  } catch (e) {
    return console.error("Error fetching product favorite status:", e), null;
  }
}
async function Uv() {
  const o = S();
  try {
    const { status: e } = await C.post(
      `${o.datasetUrls.productFavoritePath}`,
      void 0
    );
    if ([200, 204].includes(e)) return !0;
  } catch (e) {
    return console.error("Error adding favorite product:", e), null;
  }
}
async function Av() {
  const o = S();
  try {
    const { status: e } = await C.delete(
      `${o.datasetUrls.productFavoritePath}`
    );
    if ([200, 204].includes(e)) return !0;
  } catch (e) {
    return console.error("Error removing favorite product:", e), null;
  }
}
async function Tv() {
  const o = S();
  try {
    const { data: e } = await C.get(
      `${o.datasetUrls.getDeliveryDatesPath}`
    );
    return e.data?.map((t) => ({
      ...t.attributes,
      isPromoted: !!t.attributes.isPromoted,
      priority: t.attributes.priority ?? 0,
      deliveryDate: co(t.attributes.deliveryDate)
    }));
  } catch (e) {
    return console.error("Error retrieving delivery dates:", e), null;
  }
}
const E = ue("product", () => {
  const { t: o } = I(), e = D(null), t = D(null), n = D(!1), a = z(
    () => e.value?.availability.isAvailable && e.value.status === "active"
  ), l = z(() => e.value?.status === "archived"), s = z(() => e.value?.status === "pre_order"), u = z(
    () => e.value?.availability.pharmacyAvailabilityCount && e.value?.availability.pharmacyAvailabilityCount > 0
  ), _ = z(() => !!e.value?.isPersonalPickupAvailable);
  async function p() {
    const v = me("benuToast");
    try {
      n.value = !1, e.value = await Cv();
    } catch {
      v?.({ message: o("failed_to_load_product_detail_data"), duration: 1 / 0, type: "error" }), e.value = null;
    } finally {
      n.value = !0, Sv();
    }
  }
  async function j() {
    try {
      t.value = (await Mv())?.isFavorite ?? null;
    } catch {
      t.value = null;
    }
  }
  async function P() {
    t.value = !0;
    try {
      const v = await Uv();
      if (xv(), !v)
        throw new Error();
    } catch {
      t.value = null;
    }
  }
  async function k() {
    t.value = !1;
    try {
      if (!await Av())
        throw new Error();
    } catch {
      t.value = null;
    }
  }
  return {
    productData: e,
    isFavorite: t,
    loaded: n,
    isProductOrderable: a,
    isProductArchived: l,
    isProductForPreOrder: s,
    hasProductOTCReservations: u,
    isPersonalPickupAvailable: _,
    fetchDetail: p,
    fetchFavoriteStatus: j,
    addFavorite: P,
    removeFavorite: k
  };
}), Rv = ["aria-label"], Zv = {
  key: 0,
  class: "flex shrink-0 flex-col space-y-1 overflow-y-auto"
}, Lv = ["aria-label", "onClick"], Bv = {
  key: 0,
  class: "absolute inset-0 flex flex-col items-center justify-center bg-black/50 p-2 text-secondary-50 transition-colors duration-300 hover:bg-black/80"
}, Ov = { class: "text-desktop-headline-l font-bold leading-none" }, Iv = { class: "text-desktop-body-m" }, Fv = { class: "group relative flex-1 sm:flex sm:flex-col sm:justify-center" }, Jv = ["aria-label"], Kv = ["aria-label"], Qv = ["aria-label"], Hv = {
  key: 1,
  class: "mx-auto mt-2.5 flex w-fit items-center justify-center space-x-2 overflow-x-auto rounded-full bg-gray-100 px-2.5 py-1"
}, Wv = ["aria-label", "onClick"], Q = 7, Yv = /* @__PURE__ */ w({
  __name: "ProductDetailGallery",
  setup(o) {
    const { sm: e } = be(), t = E(), { productData: n } = T(t), a = {
      small: "product-128x128-webp",
      medium: "product-640x640-webp",
      large: "product-960x960-webp"
    }, l = pe("slider"), s = D(0), u = z(() => s.value === 0), _ = z(() => s.value === p.value.length - 1), p = z(
      () => n.value?.images.length ? n.value.images : [
        {
          id: "no-product-image",
          filename: "no-product-image",
          extension: "png",
          source: "external",
          title: "No product image",
          path: "/images/product-detail/no-product-image.png",
          url: null
        }
      ]
    ), j = z(() => e.value ? p.value.slice(0, Q) : []), P = z(() => p.value.length - Q), k = D(!1);
    function v() {
      k.value = !0;
    }
    function R() {
      l.value && (s.value = Math.round(l.value.scrollLeft / l.value.clientWidth));
    }
    function M(q) {
      s.value = q, l.value && l.value.scrollTo({
        left: l.value.clientWidth * q,
        behavior: "smooth"
      });
    }
    function J(q) {
      M(q), v();
    }
    return (q, b) => (c(), d("div", {
      class: "gap-x-5 sm:flex md:items-start",
      "aria-label": q.$t("product_detail_gallery")
    }, [
      j.value.length ? (c(), d("div", Zv, [
        (c(!0), d(g, null, V(j.value, (f, x) => (c(), d("button", {
          key: x,
          "aria-label": q.$t("go_to_image", { imageNumber: x + 1 }),
          "aria-hidden": "true",
          tabindex: "-1",
          onClick: (Z) => x + 1 === Q && P.value > 0 ? J(x) : M(x),
          class: $([
            "size-[88px]",
            "relative",
            "overflow-hidden rounded border",
            "transition-colors duration-300",
            s.value === x ? "border-secondary-500" : "border-transparent hover:border-secondary-300"
          ])
        }, [
          h(H, {
            class: "h-full w-full object-contain",
            "image-size": a.small,
            image: f
          }, null, 8, ["image-size", "image"]),
          x + 1 === Q && P.value > 0 ? (c(), d("div", Bv, [
            r("span", Ov, "+" + m(P.value), 1),
            r("span", Iv, m(q.$t("show_all_images")), 1)
          ])) : y("", !0)
        ], 10, Lv))), 128))
      ])) : y("", !0),
      h(Ke, {
        title: i(n)?.name,
        "modal-open": k.value,
        "onUpdate:modalOpen": b[0] || (b[0] = (f) => k.value = f),
        "current-slide": s.value,
        images: p.value,
        "image-size": a.large,
        "thumb-size": a.small,
        "z-index": 1001,
        "onUpdate:currentSlide": M
      }, null, 8, ["title", "modal-open", "current-slide", "images", "image-size", "thumb-size"]),
      r("div", Fv, [
        r("button", {
          "aria-label": q.$t("show_gallery"),
          class: $([
            "absolute right-3 top-3 md:right-5 md:top-5",
            "flex items-center justify-center",
            "size-10 rounded-full shadow-level-2",
            "transition-colors duration-300 hover:bg-gray-100 hover:text-gray-900 group-hover:bg-gray-100 group-hover:text-gray-900"
          ]),
          onClick: v,
          "aria-hidden": "true",
          tabindex: "-1"
        }, b[3] || (b[3] = [
          r("span", {
            "aria-hidden": "true",
            role: "img",
            class: "iconify-[iconamoon--zoom-in-light] size-6"
          }, null, -1)
        ]), 8, Jv),
        r("div", {
          ref_key: "slider",
          ref: l,
          class: "scrollbar-hide flex h-full max-h-[344px] cursor-pointer snap-x snap-mandatory overflow-x-auto sm:max-h-[630px]",
          onClick: v,
          onScroll: R,
          "aria-hidden": "true",
          tabindex: "-1"
        }, [
          (c(!0), d(g, null, V(p.value, (f, x) => (c(), d("div", {
            key: x,
            class: "w-full flex-none snap-center"
          }, [
            h(H, {
              class: "aspect-square h-full w-full object-scale-down",
              image: f,
              "image-size": a.medium,
              "data-cy": `product-${f?.id}-picture`
            }, null, 8, ["image", "image-size", "data-cy"])
          ]))), 128))
        ], 544),
        i(e) ? (c(), d(g, { key: 0 }, [
          u.value ? y("", !0) : (c(), d("button", {
            key: 0,
            "aria-label": q.$t("previous_image"),
            class: "absolute left-4 top-1/2 flex size-10 -translate-y-1/2 items-center justify-center rounded-full bg-white text-gray-600 opacity-0 shadow-level-1 transition-all duration-300 hover:bg-gray-100 hover:text-gray-900 group-hover:opacity-100",
            onClick: b[1] || (b[1] = (f) => !u.value && M(s.value - 1))
          }, b[4] || (b[4] = [
            r("span", {
              "aria-hidden": "true",
              role: "img",
              class: "iconify-[mdi--chevron-left] size-8"
            }, null, -1)
          ]), 8, Kv)),
          _.value ? y("", !0) : (c(), d("button", {
            key: 1,
            "aria-label": q.$t("next_image"),
            class: "absolute right-4 top-1/2 flex size-10 -translate-y-1/2 items-center justify-center rounded-full bg-white text-gray-600 opacity-0 shadow-level-1 transition-all duration-300 hover:bg-gray-100 hover:text-gray-900 group-hover:opacity-100",
            onClick: b[2] || (b[2] = (f) => !_.value && M(s.value + 1))
          }, b[5] || (b[5] = [
            r("span", {
              "aria-hidden": "true",
              role: "img",
              class: "iconify-[mdi--chevron-right] size-8"
            }, null, -1)
          ]), 8, Qv))
        ], 64)) : (c(), d("div", Hv, [
          (c(!0), d(g, null, V(p.value, (f, x) => (c(), d("button", {
            key: x,
            "aria-label": q.$t("go_to_image", { imageNumber: x + 1 }),
            class: $([s.value === x ? "bg-primary-500" : "bg-gray-300", "size-2 rounded-full"]),
            onClick: (Z) => M(x)
          }, null, 10, Wv))), 128))
        ]))
      ])
    ], 8, Rv));
  }
}), Gv = ["aria-label"], Xv = ["aria-label"], ey = "iconify-[mdi--star]", oy = "iconify-[mdi--star-half-full]", ty = "iconify-[mdi--star-outline]", ny = /* @__PURE__ */ w({
  __name: "StarRating",
  props: {
    rating: {},
    reviewsCount: {}
  },
  setup(o) {
    const e = o, { t } = I(), n = z(() => `(${e.reviewsCount ?? 0} ${t("general_reviews").toLowerCase()})`), a = z(() => {
      const u = e.rating % 1, _ = Math.floor(e.rating) + (u > 0.75 ? 1 : 0), p = u > 0.25 && u <= 0.75;
      return Array(5).fill(null).map((j, P) => ({
        index: P,
        classes: l(P, _, p)
      }));
    });
    function l(u, _, p) {
      return u < _ ? ey : u === _ && p ? oy : ty;
    }
    function s() {
      const u = "reviews";
      window.location.hash = u, document.getElementById(u)?.querySelector(`[href*="#${u}"]`)?.dispatchEvent(new Event("click"));
    }
    return (u, _) => (c(), d("div", {
      class: "flex items-center",
      "aria-label": `${u.$t("general_reviews")}: ${u.rating} ${u.$t("general_out_of")} 5`
    }, [
      (c(!0), d(g, null, V(a.value, (p) => (c(), d("span", {
        key: p.index,
        class: $([p.classes, "size-3.5 text-yellow-500 sm:size-3"]),
        "aria-hidden": "true"
      }, null, 2))), 128)),
      r("a", {
        href: "#reviews",
        class: "ml-1 text-mobile-body-s text-secondary-700 sm:text-desktop-body-s",
        "aria-label": `${n.value}`,
        onClick: U(s, ["prevent"])
      }, m(n.value), 9, Xv)
    ], 8, Gv));
  }
}), ay = ["aria-pressed", "aria-label"], ry = /* @__PURE__ */ w({
  __name: "FavoriteItemToggle",
  setup(o) {
    const e = E(), { isFavorite: t } = T(e), { fetchFavoriteStatus: n, addFavorite: a, removeFavorite: l } = e;
    function s() {
      t.value ? l() : a();
    }
    return n(), (u, _) => (c(), d("button", {
      "aria-live": "polite",
      "aria-pressed": !!i(t),
      "aria-label": u.$t("toggle_favourite"),
      class: $([
        i(t) ? "iconify-[mdi--heart] text-red-400" : "iconify-[mdi--heart-outline] text-[#ACACAC]",
        "hover:text-red-400 hover:shadow-md",
        "size-7"
      ]),
      onClick: s
    }, _[0] || (_[0] = [
      r("span", { "aria-hidden": "true" }, null, -1)
    ]), 10, ay));
  }
}), iy = {
  key: 0,
  class: "flex flex-col gap-y-2 md:gap-y-3"
}, sy = { class: "order-3 flex flex-col gap-y-2 md:gap-y-3" }, cy = { class: "text-mobile-headline-xl font-bold text-secondary-700 sm:text-desktop-headline-xl" }, ly = { class: "order-1 flex items-center justify-between" }, dy = /* @__PURE__ */ w({
  __name: "ProductInfo",
  setup(o) {
    const e = E(), { productData: t } = T(e), n = z(() => t.value?.tags);
    function a() {
      t.value?.brand && ee(`/${t.value.brand.alias}`);
    }
    return (l, s) => i(t) ? (c(), d("div", iy, [
      r("div", sy, [
        r("h1", cy, m(i(t).name), 1),
        h(ny, {
          rating: i(t).reviewSummary.value,
          "reviews-count": i(t).reviewSummary.count
        }, null, 8, ["rating", "reviews-count"])
      ]),
      r("div", ly, [
        i(t).brand ? (c(), d("a", {
          key: 0,
          href: "#",
          class: "text-mobile-body-m text-secondary-700 sm:text-desktop-body-m",
          onClick: U(a, ["prevent"])
        }, m(i(t).brand.name), 1)) : y("", !0),
        i(t).notForSaleSeparately ? y("", !0) : (c(), N(ry, { key: 1 }))
      ]),
      n.value?.length ? (c(), N(te, {
        key: 0,
        class: "order-2",
        tags: n.value
      }, null, 8, ["tags"])) : y("", !0)
    ])) : y("", !0);
  }
}), uy = { class: "flex items-center gap-x-2" }, _y = ["textContent"], py = ["textContent"], my = {
  key: 0,
  class: "flex items-center gap-x-2"
}, ky = ["textContent"], vy = ["src"], yy = /* @__PURE__ */ w({
  __name: "ProductPrice",
  props: {
    price: {}
  },
  setup(o) {
    const e = o, { web: t, loyaltyProgramme: n } = Y;
    return (a, l) => (c(), d("div", null, [
      r("div", uy, [
        r("span", {
          class: $([
            "text-mobile-headline-xxxl sm:text-desktop-headline-xxxl",
            "font-bold",
            e.price.showDiscount ? "text-red-400" : "text-secondary-700"
          ]),
          textContent: m(i(L)(e.price.price))
        }, null, 10, _y),
        e.price.showDiscount && e.price.rrpPrice ? (c(), d("s", {
          key: 0,
          class: "text text-mobile-body-l text-secondary-700 line-through sm:text-desktop-body-l",
          textContent: m(i(L)(e.price.rrpPrice))
        }, null, 8, py)) : y("", !0)
      ]),
      e.price.loyaltyPrice && i(n)?.enabled ? (c(), d("div", my, [
        r("span", {
          class: $(["text-mobile-headline-l sm:text-desktop-headline-l", "font-bold", i(n).color.text]),
          textContent: m(i(L)(e.price.loyaltyPrice))
        }, null, 10, ky),
        r("a", {
          href: "#",
          onClick: l[0] || (l[0] = U((s) => i(ee)(i(n).url, { target: "_blank" }), ["prevent"]))
        }, [
          r("img", {
            src: `/images/product-detail/${i(t)}/loyalty-programme.png`,
            class: "size-9 object-contain sm:size-10",
            alt: ""
          }, null, 8, vy)
        ])
      ])) : y("", !0)
    ]));
  }
}), hy = { class: "flex flex-col gap-1.5 pt-2 text-secondary-700" }, by = { class: "flex items-center gap-x-1" }, fy = { class: "text-mobile-headline-l font-bold sm:text-desktop-headline-m" }, zy = { class: "text-mobile-body-m sm:text-desktop-body-m" }, gy = {
  key: 0,
  class: "flex items-center gap-x-2 rounded-lg bg-green-50 px-7 py-5 md:gap-x-2.5"
}, $y = { class: "text-mobile-body-m sm:text-desktop-body-l" }, jy = { key: 1 }, Py = {
  key: 0,
  class: "mb-3 flex items-center md:order-last md:col-span-2"
}, wy = ["href", "textContent"], xy = /* @__PURE__ */ w({
  __name: "ProductWatchdogSubscription",
  props: {
    productId: {}
  },
  setup(o) {
    const { productWatchdog: e } = Y, {
      datasetUrls: { termsAndConditionsLink: t }
    } = S(), n = o, { t: a } = I(), { handleSubmit: l, isSubmitting: s, validateField: u } = Qe({
      initialValues: {
        email: "",
        consent: !1
      },
      validationSchema: He({
        email: Ye().email(a("email_invalid")).required(a("email_required")).defined(""),
        ...e?.termsAndConditionsConsentRequired && {
          consent: We().required(a("watchdog_consent_required")).oneOf([!0], a("watchdog_consent_required")).defined()
        }
      }).defined()
    }), _ = D(!1), p = D(!1), { value: j, errorMessage: P } = se("email"), { value: k, errorMessage: v } = se("consent"), R = z(() => {
      if (!p.value && _.value && P.value)
        return P.value;
    }), M = Ge(async () => {
      await u("email"), _.value = !!P.value;
    }, 1e3);
    Ae(j, () => {
      _.value = !1, M();
    });
    const J = me("benuToast"), q = l(async (b) => {
      try {
        if ((await Ev([+n.productId], b.email, b.consent))?.status === 201)
          p.value = !0, j.value = "", k.value = !1, J?.({ message: a("watch_dog_success"), type: "success" });
        else
          throw new Error();
      } catch {
        J?.({ message: a("watch_dog_error"), type: "error" });
      }
    });
    return (b, f) => {
      const x = Te("i18n-t");
      return c(), d("div", hy, [
        r("div", by, [
          f[3] || (f[3] = r("span", { class: "iconify-[mdi--pets] size-5" }, null, -1)),
          r("span", fy, m(b.$t("watch_dog_setup_prompt")), 1)
        ]),
        r("div", zy, m(b.$t("watch_dog_stock_email_info")), 1),
        p.value ? (c(), d("div", gy, [
          f[4] || (f[4] = r("span", { class: "iconify-[icon-park-outline--check-one] size-7 text-primary-500" }, null, -1)),
          r("span", $y, m(b.$t("watch_dog_setup_confirmation")), 1)
        ])) : (c(), d("div", jy, [
          r("form", {
            class: "grid grid-cols-1 gap-x-3 md:grid-cols-[1fr_auto]",
            onSubmit: f[2] || (f[2] = U(
              //@ts-ignore
              (...Z) => i(q) && i(q)(...Z),
              ["prevent"]
            ))
          }, [
            h(Xe, {
              modelValue: i(j),
              "onUpdate:modelValue": f[0] || (f[0] = (Z) => ie(j) ? j.value = Z : null),
              class: "mb-6 md:mb-5",
              name: "subscription-email",
              placeholder: b.$t("email_placeholder"),
              message: R.value || i(v),
              error: _.value || !!i(v)
            }, null, 8, ["modelValue", "placeholder", "message", "error"]),
            i(e)?.termsAndConditionsConsentRequired ? (c(), d("div", Py, [
              h(i(we), {
                modelValue: i(k),
                "onUpdate:modelValue": f[1] || (f[1] = (Z) => ie(k) ? k.value = Z : null),
                name: "watchdog-consent",
                value: "consent"
              }, {
                default: A(() => [
                  h(x, {
                    tag: "span",
                    keypath: "general_i_agree_with"
                  }, {
                    link: A(() => [
                      r("a", {
                        href: i(t),
                        target: "_blank",
                        textContent: m(b.$t("watchdog_consent_terms_conditions"))
                      }, null, 8, wy)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])) : y("", !0),
            h(i(O), {
              type: "submit",
              class: "h-fit px-4 md:w-fit",
              variant: "primary",
              label: b.$t("let_me_know"),
              loading: i(s),
              disabled: p.value
            }, null, 8, ["label", "loading", "disabled"])
          ], 32)
        ]))
      ]);
    };
  }
}), qy = { class: "flex items-center justify-between border-b border-t border-secondary-200 py-2 sm:rounded-md sm:border sm:px-2 sm:py-1.5 md:max-w-32" }, Sy = { class: "text-mobile-body-l font-bold text-primary-500 sm:text-desktop-body-l" }, Ny = /* @__PURE__ */ w({
  __name: "QuantityControl",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(o) {
    const e = F(), { isChangingQuantity: t } = T(e), n = ke(o, "modelValue"), a = z(() => n.value <= 1), l = z(() => n.value >= 100);
    return (s, u) => (c(), d("div", qy, [
      h(i(ae), {
        class: "size-12 rounded-sm bg-primary-100 hover:bg-primary-200 disabled:bg-secondary-50 sm:size-8",
        disabled: a.value || i(t),
        onClick: u[0] || (u[0] = U((_) => n.value--, ["prevent"])),
        "aria-label": s.$t("general_decrease_quantity")
      }, {
        default: A(() => [
          r("span", {
            class: $(["pi pi-minus", a.value ? "text-gray-200" : "text-primary-600"])
          }, null, 2)
        ]),
        _: 1
      }, 8, ["disabled", "aria-label"]),
      r("div", Sy, m(n.value), 1),
      h(i(ae), {
        class: "size-12 rounded-sm bg-primary-100 hover:bg-primary-200 disabled:bg-secondary-50 sm:size-8",
        disabled: l.value || i(t),
        onClick: u[1] || (u[1] = U((_) => n.value++, ["prevent"])),
        "aria-label": s.$t("general_increase_quantity")
      }, {
        default: A(() => [
          r("span", {
            class: $(["pi pi-plus", l.value ? "text-gray-200" : "text-primary-600"])
          }, null, 2)
        ]),
        _: 1
      }, 8, ["disabled", "aria-label"])
    ]));
  }
}), Dy = { class: "flex flex-col gap-3 pt-3 sm:flex-row sm:pb-2 sm:pt-0" }, Vy = /* @__PURE__ */ w({
  __name: "PurchaseForm",
  props: {
    id: {}
  },
  setup(o) {
    const e = o, t = F(), { addToBasket: n } = t, { isChangingQuantity: a } = T(t), l = D(1);
    function s() {
      n(e.id, l.value);
    }
    return (u, _) => (c(), d("form", Dy, [
      h(Ny, {
        modelValue: l.value,
        "onUpdate:modelValue": _[0] || (_[0] = (p) => l.value = p),
        class: "sm:w-1/2 md:w-auto md:grow"
      }, null, 8, ["modelValue"]),
      h(i(O), {
        type: "submit",
        variant: "primary",
        class: "sm:w-1/2 md:w-auto md:grow",
        label: u.$t("general_buy"),
        loading: i(a),
        onClick: U(s, ["prevent"])
      }, null, 8, ["label", "loading"])
    ]));
  }
}), Cy = {
  key: 0,
  class: "flex flex-col gap-y-2"
}, Ey = {
  key: 0,
  class: "flex items-center gap-x-1"
}, My = { class: "text-mobile-body-m text-secondary-700 sm:text-desktop-body-m" }, Uy = { class: "text-mobile-body-m text-gray-400 sm:text-desktop-body-m" }, Ay = /* @__PURE__ */ w({
  __name: "ProductPurchaseControls",
  setup(o) {
    const e = E(), { productData: t, isProductOrderable: n, isProductArchived: a, isProductForPreOrder: l } = T(e), s = z(() => t.value?.price);
    return (u, _) => i(t) ? (c(), d("div", Cy, [
      i(t).notForSaleSeparately || i(a) ? (c(), N(i(O), {
        key: 0,
        variant: "primary",
        disabled: "",
        label: i(a) ? u.$t("archived_product") : u.$t("not_for_sale_separately")
      }, null, 8, ["label"])) : (c(), d(g, { key: 1 }, [
        s.value ? (c(), d(g, { key: 0 }, [
          h(yy, { price: s.value }, null, 8, ["price"]),
          s.value.unitPrice ? (c(), d("div", Ey, [
            _[0] || (_[0] = r("span", { class: "iconify-[ri--scales-3-line] size-4 text-secondary-700" }, null, -1)),
            r("span", My, m(u.$t("unit_price_label", { unitText: s.value.unitPrice.unitText })) + " " + m(i(L)(s.value.unitPrice.price, { minimumFractionDigits: 0, maximumFractionDigits: 2 })), 1)
          ])) : y("", !0),
          h(i(xe), {
            class: "flex cursor-help items-center gap-x-1 self-start",
            text: u.$t("internet_price_tooltip")
          }, {
            default: A(() => [
              _[1] || (_[1] = r("span", { class: "iconify-[mdi--information-outline] size-[18px] text-gray-400" }, null, -1)),
              r("span", Uy, m(u.$t("internet_price")), 1)
            ]),
            _: 1,
            __: [1]
          }, 8, ["text"])
        ], 64)) : y("", !0),
        i(n) ? (c(), N(Vy, {
          key: 1,
          id: i(t).id
        }, null, 8, ["id"])) : (c(), d(g, { key: 2 }, [
          h(i(O), {
            variant: "primary",
            disabled: "",
            label: i(l) ? u.$t("pre_order_product") : u.$t("general_unavailable"),
            "aria-label": u.$t("general_unavailable_product")
          }, null, 8, ["label", "aria-label"]),
          h(xy, {
            "product-id": i(t).id
          }, null, 8, ["product-id"])
        ], 64))
      ], 64))
    ])) : y("", !0);
  }
}), Ty = { class: "mb-2 flex overflow-hidden rounded-md bg-yellow-500" }, Ry = {
  key: 0,
  class: "flex h-full items-center justify-center bg-yellow-500 p-5"
}, Zy = { class: "flex items-center justify-between" }, Ly = { class: "text-mobile-body-l font-bold text-secondary-700 sm:text-desktop-headline-s" }, By = ["href"], Oy = { class: "text-mobile-body-m text-secondary-700 sm:text-desktop-body-m" }, Iy = ["href"], Fy = {
  key: 1,
  class: "text-mobile-body-s text-gray-700 sm:text-desktop-body-s"
}, Jy = /* @__PURE__ */ w({
  __name: "SpecialOfferBadge",
  props: {
    offer: {}
  },
  setup(o) {
    const e = o;
    return (t, n) => (c(), d("div", Ty, [
      e.offer.gifts?.length ? (c(), d("div", Ry, n[0] || (n[0] = [
        r("span", { class: "iconify-[iconoir--gift] size-8 text-yellow-100" }, null, -1)
      ]))) : y("", !0),
      r("div", {
        class: $([
          "flex grow flex-col px-5 py-4",
          e.offer.gifts?.length ? "gap-y-1.5 border border-secondary-50 bg-white md:gap-y-2" : "gap-y-2 bg-yellow-500 md:gap-y-2.5"
        ])
      }, [
        r("div", Zy, [
          r("h3", Ly, m(e.offer.name), 1),
          e.offer.url ? (c(), d("a", {
            key: 0,
            href: e.offer.url,
            class: "text-body-m"
          }, m(t.$t("general_more")), 9, By)) : y("", !0)
        ]),
        r("div", Oy, [
          h(re, {
            message: e.offer.description
          }, null, 8, ["message"])
        ]),
        e.offer.gifts?.length ? (c(!0), d(g, { key: 0 }, V(e.offer.gifts, (a) => (c(), d("div", {
          key: a.id,
          class: "flex items-center gap-2.5"
        }, [
          h(H, {
            class: "size-9 rounded-md object-contain md:size-10",
            image: a.image,
            "image-size": "img-small-product"
          }, null, 8, ["image"]),
          r("a", {
            href: i(qe)(a.alias),
            class: "text-mobile-body-s text-secondary-700 underline sm:text-desktop-body-m"
          }, m(a.name) + " " + m(a.quantity) + " " + m(t.$t("general_piece_abbr")), 9, Iy)
        ]))), 128)) : y("", !0),
        e.offer.disclaimer ? (c(), d("div", Fy, [
          h(re, {
            message: e.offer.disclaimer
          }, null, 8, ["message"])
        ])) : y("", !0)
      ], 2)
    ]));
  }
}), W = (o) => {
  const { t: e } = I();
  if (o <= /* @__PURE__ */ new Date())
    return e("date_immediately");
  if (io(o))
    return e("date_today");
  if (so(o))
    return e("date_tomorrow");
  const t = no(o, "EEEE d.M.", { locale: ao });
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Ky = { class: "flex flex-col gap-3 p-4 md:gap-7 md:px-10 md:py-11" }, Qy = { class: "text-mobile-headline-l text-secondary-700 md:text-desktop-headline-l" }, Hy = { class: "flex flex-col gap-3" }, Wy = { class: "text-mobile-body-m text-secondary-300 md:text-desktop-body-m" }, Yy = { class: "flex flex-col gap-3" }, Gy = { class: "text-secondary-700" }, Xy = { class: "text-end text-primary-500" }, eh = { class: "flex flex-col gap-3" }, oh = { class: "text-secondary-700" }, th = { class: "text-end text-primary-500" }, nh = /* @__PURE__ */ w({
  __name: "DeliveryModal",
  props: /* @__PURE__ */ Re({
    deliveries: {}
  }, {
    open: { type: Boolean },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(o) {
    const e = ke(o, "open"), t = z(() => o.deliveries.filter((a) => a.deliveryMethodType === "carrier_delivery")), n = z(() => o.deliveries.filter((a) => a.deliveryMethodType === "personal_pickup"));
    return (a, l) => (c(), N(i(Se), {
      visible: e.value,
      "onUpdate:visible": l[0] || (l[0] = (s) => e.value = s)
    }, {
      default: A(() => [
        r("div", Ky, [
          r("h1", Qy, m(a.$t("all_delivery_options")), 1),
          r("div", Hy, [
            n.value.length ? (c(), d(g, { key: 0 }, [
              r("h2", Wy, m(a.$t("personal_pickup")), 1),
              r("ul", Yy, [
                (c(!0), d(g, null, V(n.value, (s) => (c(), d("li", {
                  class: "flex items-center justify-between gap-3 border-b pb-3 text-mobile-body-l md:text-desktop-body-l",
                  key: s.deliveryMethodId
                }, [
                  r("span", Gy, m(s.deliveryMethodName), 1),
                  r("span", Xy, m(i(W)(s.deliveryDate)), 1)
                ]))), 128))
              ])
            ], 64)) : y("", !0),
            t.value.length ? (c(), d(g, { key: 1 }, [
              r("h2", {
                class: $([
                  "text-mobile-body-m text-secondary-300 md:text-desktop-body-m",
                  { "md:pt-7": n.value.length }
                ])
              }, m(a.$t("carrier_delivery")), 3),
              r("ul", eh, [
                (c(!0), d(g, null, V(t.value, (s) => (c(), d("li", {
                  class: "flex items-center justify-between gap-3 border-b pb-3 text-mobile-body-l md:text-desktop-body-l",
                  key: s.deliveryMethodId
                }, [
                  r("span", oh, m(s.deliveryMethodName), 1),
                  r("span", th, m(i(W)(s.deliveryDate)), 1)
                ]))), 128))
              ])
            ], 64)) : y("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]));
  }
}), ah = /* @__PURE__ */ Ne(nh, [["__scopeId", "data-v-e2547173"]]), rh = ["aria-label"], ih = { class: "flex items-center gap-x-2 text-secondary-700" }, sh = { class: "text-mobile-body-m sm:text-desktop-body-m" }, ch = {
  key: 1,
  class: "flex items-center gap-x-2 text-secondary-700"
}, lh = { class: "text-mobile-body-m sm:text-desktop-body-m" }, dh = ["innerHTML"], uh = ["textContent", "aria-label"], _h = {
  key: 2,
  class: "flex items-center gap-x-2 text-secondary-700"
}, ph = ["aria-label"], mh = {
  key: 3,
  class: "flex items-center gap-x-2 text-mobile-body-m text-secondary-700 sm:text-desktop-body-m"
}, kh = ["aria-label"], vh = { class: "lowercase text-primary-500" }, yh = {
  key: 4,
  class: "flex items-center gap-x-2 text-mobile-body-m text-secondary-700 sm:text-desktop-body-m"
}, hh = ["aria-label"], bh = { class: "lowercase text-primary-500" }, fh = {
  key: 5,
  class: "flex items-center text-mobile-body-m text-secondary-700 sm:text-desktop-body-m"
}, zh = /* @__PURE__ */ w({
  __name: "DeliveryInfo",
  async setup(o) {
    let e, t;
    const n = E(), { hasProductOTCReservations: a, isPersonalPickupAvailable: l } = T(n), s = S();
    function u() {
      try {
        ve(s.datasetUrls.otcReservationPharmaciesLink, { openPdBox: !0 });
      } catch (k) {
        console.error(k instanceof Error ? k.message : k);
      }
    }
    const _ = ([e, t] = Ze(() => Tv()), e = await e, t(), e), p = z(
      () => (_ ?? []).sort((k, v) => k.isPromoted !== v.isPromoted ? +v.isPromoted - +k.isPromoted : k.priority !== v.priority ? v.priority - k.priority : k.deliveryDate.getTime() - v.deliveryDate.getTime())[0]
    ), j = _?.find((k) => k.deliveryMethodUid === "DEL_PERSONAL"), P = D(!1);
    return (k, v) => (c(), d("section", {
      "aria-label": k.$t("product_availability"),
      class: "flex flex-col space-y-3 py-5 md:py-4"
    }, [
      i(a) ? (c(), N(te, {
        key: 0,
        tags: [
          {
            label: k.$t("otc_tag"),
            id: "otc",
            type: "otc"
          }
        ]
      }, null, 8, ["tags"])) : y("", !0),
      r("div", ih, [
        v[2] || (v[2] = r("span", { class: "iconify-[mdi--package-variant-closed] size-5" }, null, -1)),
        r("span", sh, m(k.$t("in_stock_on_e_shop")), 1)
      ]),
      i(a) ? (c(), d("div", ch, [
        v[3] || (v[3] = r("span", { class: "iconify-[mdi--run] size-5 self-start" }, null, -1)),
        r("div", lh, [
          r("div", {
            innerHTML: k.$t("immediate_pickup")
          }, null, 8, dh),
          r("a", {
            href: "#",
            onClick: U(u, ["prevent"]),
            textContent: m(k.$t("choose_pharmacy")),
            "aria-label": k.$t("choose_pharmacy")
          }, null, 8, uh)
        ])
      ])) : i(l) ? (c(), d("div", _h, [
        v[4] || (v[4] = r("span", { class: "iconify-[mdi--store-mall-directory-outline] size-5" }, null, -1)),
        r("span", {
          class: "text-mobile-body-m sm:text-desktop-body-m",
          "aria-label": k.$t("free_pickup_on_pharmacy")
        }, m(k.$t("free_pickup_on_pharmacy")), 9, ph)
      ])) : y("", !0),
      !i(a) && i(j) ? (c(), d("div", mh, [
        v[6] || (v[6] = r("span", { class: "iconify-[mdi--run] size-5 self-start" }, null, -1)),
        r("div", null, [
          r("span", {
            "aria-label": k.$t("pickup_delivery_to_you_pharmacy")
          }, m(k.$t("pickup_delivery_to_you_pharmacy")), 9, kh),
          v[5] || (v[5] = X(" ")),
          r("span", vh, m(i(W)(i(j).deliveryDate)), 1)
        ])
      ])) : y("", !0),
      p.value ? (c(), d("div", yh, [
        r("span", {
          class: $([
            "size-5",
            p.value.deliveryMethodType === "personal_pickup" ? "iconify-[mdi--package]" : "iconify-[material-symbols--local-shipping-outline-sharp]"
          ])
        }, null, 2),
        r("div", null, [
          r("span", {
            "aria-label": p.value.deliveryMethodType === "personal_pickup" ? k.$t("pickup_delivery_to_you") : k.$t("carrier_delivery_to_you")
          }, m(p.value.deliveryMethodType === "personal_pickup" ? k.$t("pickup_delivery_to_you") : k.$t("carrier_delivery_to_you")), 9, hh),
          v[7] || (v[7] = X(" ")),
          r("span", bh, m(i(W)(p.value.deliveryDate)), 1)
        ])
      ])) : y("", !0),
      i(_)?.length ? (c(), d("div", fh, [
        r("button", {
          class: "underline underline-offset-2 hover:no-underline",
          onClick: v[0] || (v[0] = (R) => P.value = !P.value)
        }, m(k.$t("all_delivery_options")), 1),
        h(ah, {
          deliveries: i(_),
          open: P.value,
          "onUpdate:open": v[1] || (v[1] = (R) => P.value = R)
        }, null, 8, ["deliveries", "open"])
      ])) : y("", !0)
    ], 8, rh));
  }
}), gh = {
  key: 0,
  class: /* @__PURE__ */ $([
    "mx-auto mb-5 max-w-screen-xl px-2 sm:px-0 md:mt-4",
    // should there be more content in the right column on desktop, increase the repeat count in md:grid-rows class
    "grid grid-cols-1 md:grid-cols-[58%_1fr] md:grid-rows-[repeat(12,min-content)] md:gap-x-16"
  ])
}, $h = {
  key: 1,
  class: "mx-auto mb-5 grid max-w-screen-xl grid-cols-1 md:mt-4 md:grid-cols-[58%_1fr] md:grid-rows-[auto_auto] md:justify-between md:gap-x-16"
}, jh = /* @__PURE__ */ w({
  __name: "App",
  setup(o) {
    const { t: e } = I(), t = E(), { loaded: n, productData: a, isProductOrderable: l, isProductArchived: s } = T(t), { fetchDetail: u } = t;
    return u(), (_, p) => i(n) && i(a) ? (c(), d("article", gh, [
      h(dy, { class: "mb-3 md:mb-5" }),
      h(Yv, { class: "sm:order-first md:row-span-full" }),
      h(Ay, { class: "mb-3 md:mb-2" }),
      i(a).variants.length ? (c(), N(le, {
        key: 0,
        "main-product-id": i(a).id,
        title: i(e)("product_variants_title"),
        products: i(a).variants
      }, null, 8, ["main-product-id", "title", "products"])) : y("", !0),
      i(a).bundles.length ? (c(), N(le, {
        key: 1,
        "main-product-id": i(a).id,
        title: i(e)("product_bundles_title"),
        products: i(a).bundles
      }, null, 8, ["main-product-id", "title", "products"])) : y("", !0),
      (c(!0), d(g, null, V(i(a).multiActions, (j) => (c(), N(Jy, {
        key: j.id,
        offer: j
      }, null, 8, ["offer"]))), 128)),
      i(l) ? (c(), d(g, { key: 2 }, [
        i(a).notForSaleSeparately ? y("", !0) : (c(), N(Le, { key: 0 }, {
          fallback: A(() => p[0] || (p[0] = [
            r("div", { class: "max-w-64" }, [
              r("div", { class: "skeleton-item mb-2 h-8" }),
              r("div", { class: "skeleton-item mb-2 h-8" }),
              r("div", { class: "skeleton-item mb-2 h-8" })
            ], -1)
          ])),
          default: A(() => [
            h(zh)
          ]),
          _: 1
        }))
      ], 64)) : (c(), d(g, { key: 3 }, [
        i(a).categories.length ? (c(), N(Zo, {
          key: 0,
          categories: i(a).categories,
          class: $({
            "mt-4 md:mt-3": i(a).variants.length || i(a).bundles.length || i(a).multiActions.length
          })
        }, null, 8, ["categories", "class"])) : y("", !0)
      ], 64)),
      !i(s) && i(a).isPrescribableMedicalDevice ? (c(), N(hv, { key: 4 })) : y("", !0)
    ])) : (c(), d("div", $h, p[1] || (p[1] = [
      Be('<div class="skeleton-item mb-2 h-20"></div><div class="md:order-first md:row-span-12 md:flex md:gap-x-5"><div class="hidden shrink-0 flex-col space-y-1 md:flex"><div class="skeleton-item size-[88px]"></div><div class="skeleton-item size-[88px]"></div><div class="skeleton-item size-[88px]"></div><div class="skeleton-item size-[88px]"></div><div class="skeleton-item size-[88px]"></div><div class="skeleton-item size-[88px]"></div><div class="skeleton-item size-[88px]"></div></div><div class="mb-1 mt-2.5 flex-1 md:m-0"><div class="skeleton-item mx-auto aspect-square max-h-[344px] md:max-h-[630px]"></div></div></div><div class="skeleton-item mb-2 h-20"></div><div class="skeleton-item mb-2 h-20"></div>', 4)
    ])));
  }
});
try {
  const { datasetKeys: o, datasetValues: e, messages: t } = De(de, {
    datasetStagingValues: $e,
    moduleLocales: mv
  }), n = Ve({
    App: jh,
    datasetKeys: o,
    datasetValues: e
  });
  n.use(Ce()), n.use(
    Ee({
      ...Y.localeSettings,
      messages: t
    })
  ), n.mount(`#${de}`);
} catch (o) {
  console.error("Failed to initialize the application:", o);
}
//# sourceMappingURL=product-detail.js.map
